import React from "react";

import styles from "../../../MainApp/layouts/Sidebar/MainApp.layouts.Sidebar.module.scss";

const getPath = (name, className, props) => {
  switch (name) {
    case "product":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.height ?? 26.581}
          height={props.height ?? 28.334}
          className={className}
          viewBox={`0 0 ${props.width ?? 26.581} ${props.height ?? 28.334}`}
        >
          <g id="Producto" transform="translate(0.2 0.203)">
            <g id="box" transform="translate(0 0)">
              <g
                id="Grupo_13543"
                data-name="Grupo 13543"
                transform="translate(0 0)"
              >
                <g id="Grupo_13542" data-name="Grupo 13542">
                  <path
                    id="Trazado_13295"
                    data-name="Trazado 13295"
                    d="M41.982,6.162,29.3.04a.409.409,0,0,0-.356,0L16.263,6.162a.409.409,0,0,0-.231.368V21.4a.409.409,0,0,0,.231.368l12.681,6.122a.409.409,0,0,0,.356,0l12.681-6.122a.409.409,0,0,0,.231-.368V6.531A.409.409,0,0,0,41.982,6.162ZM29.123.863l11.74,5.668-3.4,1.643a.4.4,0,0,0-.069-.044L25.73,2.5Zm-4.317,2.1L36.529,8.623l-2.4,1.159L22.41,4.125ZM36.8,9.4v4.285l-2.243,1.083V10.482Zm4.592,11.743L29.532,26.869V12.91l2.83-1.366a.409.409,0,0,0-.356-.737L29.123,12.2l-1.134-.548a.409.409,0,0,0-.356.737l1.081.522V26.869L16.85,21.142V7.183l9.034,4.361a.409.409,0,0,0,.356-.737L17.382,6.531l4.064-1.962L33.737,10.5l.006.007v4.91a.409.409,0,0,0,.587.368l3.061-1.478a.409.409,0,0,0,.231-.368V9l3.773-1.822Z"
                    transform="translate(-16.032 0.001)"
                    fill={props.fill}
                    stroke={props.fill}
                    strokeWidth="0.3"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case "embalaje":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28.685"
          height="27.15"
          viewBox="0 0 28.685 27.15"
        >
          <g
            id="Grupo_15937"
            data-name="Grupo 15937"
            transform="translate(-284.493 -407.553)"
          >
            <path
              id="Trazado_14639"
              data-name="Trazado 14639"
              d="M306.758,425.011H290.911a.73.73,0,0,1-.73-.731V408.433a.73.73,0,0,1,.73-.73h15.847a.73.73,0,0,1,.731.73V424.28A.731.731,0,0,1,306.758,425.011Zm-15.192-1.385H306.1V409.088H291.566Z"
              fill={props.fill}
              stroke={props.fill}
              strokeWidth="0.3"
            />
            <path
              id="Trazado_14642"
              data-name="Trazado 14642"
              d="M291.433,434.7h-3.889a.825.825,0,0,1-.824-.825v-4.713h5.538v4.713A.826.826,0,0,1,291.433,434.7Zm-3.329-1.385h2.769V430.55h-2.768Z"
              fill={props.fill}
            />
            <path
              id="Trazado_14642-2"
              data-name="Trazado 14642"
              d="M310.1,434.7h-3.889a.825.825,0,0,1-.824-.825v-4.713h5.538v4.713A.826.826,0,0,1,310.1,434.7Zm-3.329-1.385h2.769V430.55h-2.768Z"
              fill={props.fill}
            />
            <path
              id="Trazado_14644"
              data-name="Trazado 14644"
              d="M312.221,430.549H285.557a.915.915,0,0,1-.914-.915v-3.017a.914.914,0,0,1,.914-.914h26.664a.807.807,0,0,1,.807.806v3.233A.808.808,0,0,1,312.221,430.549Zm-26.486-1.384h26.2v-2.077h-26.2Z"
              fill={props.fill}
              stroke={props.fill}
              strokeWidth="0.3"
            />
            <g id="Rectángulo_24442" data-name="Rectángulo 24442">
              <g id="Grupo_15935" data-name="Grupo 15935">
                <path
                  id="Trazado_14646"
                  data-name="Trazado 14646"
                  d="M295.181,407.7h7v6.4a.6.6,0,0,1-.6.6h-5.8a.6.6,0,0,1-.6-.6Z"
                  fill="none"
                />
              </g>
              <g id="Grupo_15936" data-name="Grupo 15936">
                <path
                  id="Trazado_14647"
                  data-name="Trazado 14647"
                  d="M301.582,414.7h-5.8a.6.6,0,0,1-.6-.6v-6.4h7v6.4A.6.6,0,0,1,301.582,414.7Zm-4.9-1.5h4v-4h-4Z"
                  fill={props.fill}
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "stock":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.height ?? 38}
          height={props.height ?? 36}
          className={className}
          viewBox={`0 0 ${props.width ?? 38} ${props.height ?? 36}`}
        >
          <defs>
            <clipPath id="clip-Stock-Blanco">
              <rect width="38" height="36" />
            </clipPath>
          </defs>
          <g id="Stock-Blanco">
            <g
              id="Grupo_14773"
              data-name="Grupo 14773"
              transform="translate(-340.036 -396.859)"
            >
              <path
                id="Trazado_14413"
                data-name="Trazado 14413"
                d="M371.774,421.912h.006a.646.646,0,0,0,.647-.638V409.333a.645.645,0,0,0-.638-.652h-2.783l-.021-.178a7.481,7.481,0,0,0-14.868,0l-.02.178h-2.775a.646.646,0,0,0-.646.638V421.26a.645.645,0,0,0,.637.652h20.461Zm-10.225-18.746h0a6.163,6.163,0,1,1-6.163,6.163A6.17,6.17,0,0,1,361.55,403.166Zm-9.574,6.819h2.117l.02.178a7.481,7.481,0,0,0,14.868,0l.021-.178h2.117v10.623H351.975Z"
                fill={props.fill}
                stroke={props.fill}
                strokeWidth="0.3"
              />
              <path
                id="Trazado_14414"
                data-name="Trazado 14414"
                d="M365.43,407.19a.66.66,0,0,0-.91,0l-3.823,3.787-2.082-2.082a.643.643,0,1,0-.911.908l2.519,2.555a.712.712,0,0,0,.953,0l4.254-4.254A.644.644,0,0,0,365.43,407.19Z"
                fill={props.fill}
                stroke={props.fill}
                strokeWidth="0.3"
              />
              <path
                id="Trazado_14415"
                data-name="Trazado 14415"
                d="M373.579,424.019c-.027,0-.06,0-.094,0l-.21.009v-.013h-24.7V409.334a.769.769,0,0,0-.189-.482l-.6-.566-2.8-2.8a.645.645,0,0,0-.911.912l3.228,3.227V424.7a.645.645,0,0,0,.637.652h4.519l-.3.334a2.316,2.316,0,0,0-.594,1.565,2.355,2.355,0,1,0,4.71,0,2.316,2.316,0,0,0-.594-1.566l-.3-.334h11.6l-.3.334a2.311,2.311,0,0,0-.6,1.565,2.383,2.383,0,0,0,2.357,2.356,2.348,2.348,0,0,0,2.287-2.385,2.323,2.323,0,0,0-.6-1.571l-.3-.334h3.648a.652.652,0,1,0,.1-1.3Zm-18.943,3.944a1.04,1.04,0,0,1-.736.313h-.018a1.052,1.052,0,1,1,1.052-1.052A1.04,1.04,0,0,1,354.636,427.963Zm13.747.313h-.018a1.043,1.043,0,1,1,.018,0Z"
                fill={props.fill}
                stroke={props.fill}
                strokeWidth="0.3"
              />
            </g>
          </g>
        </svg>
      );
    case "checkbox":
      return (
        <svg
          width="16"
          height={props.height}
          viewBox="0 0 16 13"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M18 14C15.7909 14 14 15.7909 14 18V32C14 34.2091 15.7909 36 18 36H32C34.2091 36 36 34.2091 36 32V19.1213L23 32.1213L17.4393 26.5607L19.5607 24.4393L23 27.8787L35.2814 15.7119C34.5584 14.677 33.3582 14 32 14H18Z"
          />
        </svg>
      );
    case "add":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M12.583 11.5832H18.3122C19.1863 11.5832 19.8955 10.8741 19.8955 9.99998C19.8955 9.12589 19.1863 8.41675 18.3122 8.41675H12.583C12.0307 8.41675 11.583 7.96903 11.583 7.41675V1.68748C11.583 0.813385 10.8738 0.104248 9.99974 0.104248C9.12564 0.104248 8.4165 0.813385 8.4165 1.68748V7.41675C8.4165 7.96903 7.96879 8.41675 7.4165 8.41675H1.68724C0.813141 8.41675 0.104004 9.12589 0.104004 9.99998C0.104004 10.8741 0.813141 11.5832 1.68724 11.5832H7.4165C7.96879 11.5832 8.4165 12.0309 8.4165 12.5832V18.3125C8.4165 19.1866 9.12564 19.8957 9.99974 19.8957C10.8738 19.8957 11.583 19.1866 11.583 18.3125V12.5832C11.583 12.0309 12.0307 11.5832 12.583 11.5832Z"
          />
        </svg>
      );
    case "applications":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M13.091 0H2.18195C1.18195 0 0.36377 0.818182 0.36377 1.81818V14.5455H2.18195V1.81818H13.091V0ZM15.8183 3.63636H5.81831C4.81831 3.63636 4.00013 4.45455 4.00013 5.45455V18.1818C4.00013 19.1818 4.81831 20 5.81831 20H15.8183C16.8183 20 17.6365 19.1818 17.6365 18.1818V5.45455C17.6365 4.45455 16.8183 3.63636 15.8183 3.63636ZM15.8183 18.1818H5.81831V5.45455H15.8183V18.1818Z"
          />
        </svg>
      );
    case "arrow":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 13 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM13 3.5L1 3.5V4.5L13 4.5V3.5Z"
          />
        </svg>
      );
    case "carrier":
      return (
        <svg
          {...props}
          width={props.width}
          height={props.height}
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 3H1V9H9V3ZM1 2C0.447715 2 0 2.44772 0 3V9C0 9.55228 0.447716 10 1 10H9C9.55229 10 10 9.55228 10 9V3C10 2.44772 9.55228 2 9 2H1Z"
          />
          <path
            {...props}
            d="M4 2C4 1.44772 4.44772 1 5 1C5.55228 1 6 1.44772 6 2H6.33333C6.56593 2 6.78924 2.0397 6.99688 2.1127C6.99895 2.0754 7 2.03782 7 2C7 0.895431 6.10457 0 5 0C3.89543 0 3 0.895431 3 2C3 2.03782 3.00105 2.0754 3.00312 2.1127C3.21076 2.0397 3.43408 2 3.66667 2H4Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 3H3V9H7V3ZM2 2V10H8V2H2Z"
          />
        </svg>
      );
    case "check":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M1.99984 11.4853L5.53537 15.0208C6.70694 16.1924 8.60644 16.1924 9.77801 15.0208L16.6588 8.14001"
            stroke={props.fill}
            strokeWidth="2.7"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
      );
    case "check-checkbox":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 16 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5608 2.56065L6.00011 12.1213L0.939453 7.06065L3.06077 4.93933L6.00011 7.87867L13.4395 0.439331L15.5608 2.56065Z"
          />
        </svg>
      );
    case "chevron-down":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 15 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              {...props}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.7857 1.32027C14.3129 1.84748 14.3129 2.70225 13.7857 3.22946L7.55297 9.46222L1.32021 3.22946C0.793003 2.70225 0.793003 1.84748 1.32021 1.32027C1.84742 0.793064 2.70219 0.793064 3.2294 1.32027L7.55297 5.64385L11.8765 1.32027C12.4038 0.793064 13.2585 0.793064 13.7857 1.32027Z"
            />
            <path
              {...props}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.7857 1.32027C14.3129 1.84748 14.3129 2.70225 13.7857 3.22946L10.6289 6.38631C8.93011 8.08509 6.17584 8.08509 4.47706 6.38631L1.32021 3.22946C0.793003 2.70225 0.793003 1.84748 1.32021 1.32027C1.84742 0.793064 2.70219 0.793064 3.2294 1.32027L6.38625 4.47712C7.03061 5.12148 8.07533 5.12148 8.7197 4.47712L11.8765 1.32027C12.4038 0.793064 13.2585 0.793064 13.7857 1.32027Z"
            />
          </g>
        </svg>
      );
    case "chevron-right":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 8 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M0.414537 0.783299C0.233556 0.984674 0.143067 1.21702 0.143067 1.48036C0.143067 1.7437 0.233556 1.97605 0.414537 2.17742L5.54985 7.42861L0.414537 12.6798C0.233556 12.8812 0.143066 13.1135 0.143066 13.3769C0.143066 13.6402 0.233556 13.8725 0.414537 14.0739C0.6106 14.2753 0.836823 14.376 1.09321 14.376C1.3496 14.376 1.57583 14.2753 1.77189 14.0739L7.56326 8.12567C7.66883 8.01724 7.74424 7.89719 7.78949 7.76552C7.83473 7.63385 7.85735 7.52155 7.85735 7.42861C7.85735 7.33567 7.83473 7.22336 7.78949 7.0917C7.74424 6.96003 7.66883 6.83998 7.56326 6.73155L1.77189 0.783299C1.57583 0.581925 1.3496 0.48124 1.09321 0.48124C0.836823 0.48124 0.6106 0.581925 0.414537 0.783299Z"
          />
        </svg>
      );
    case "chevron-up":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 14 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              {...props}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.547761 9.01307C0.0205537 8.48586 0.0205537 7.63109 0.547761 7.10388L6.78052 0.87112L13.0133 7.10388C13.5405 7.63109 13.5405 8.48586 13.0133 9.01307C12.4861 9.54028 11.6313 9.54028 11.1041 9.01307L6.78052 4.6895L2.45695 9.01307C1.92974 9.54028 1.07497 9.54028 0.547761 9.01307Z"
            />
            <path
              {...props}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.547761 9.01307C0.0205537 8.48586 0.0205537 7.63109 0.547761 7.10388L3.70461 3.94704C5.40339 2.24826 8.15766 2.24825 9.85644 3.94703L13.0133 7.10388C13.5405 7.63109 13.5405 8.48586 13.0133 9.01307C12.4861 9.54028 11.6313 9.54028 11.1041 9.01307L7.94725 5.85622C7.30288 5.21186 6.25816 5.21186 5.6138 5.85622L2.45695 9.01307C1.92974 9.54028 1.07497 9.54028 0.547761 9.01307Z"
            />
          </g>
        </svg>
      );
    case "close":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M12.7071 14.5926L16.007 17.8925C16.5275 18.413 17.372 18.413 17.8925 17.8925C18.413 17.372 18.413 16.5275 17.8925 16.007L14.5926 12.7071C14.2021 12.3166 14.2021 11.6834 14.5926 11.2929L17.8925 7.993C18.413 7.47251 18.413 6.62799 17.8925 6.1075C17.372 5.58701 16.5275 5.58701 16.007 6.1075L12.7071 9.40739C12.3166 9.79791 11.6834 9.79791 11.2929 9.40739L7.993 6.1075C7.47251 5.58701 6.62799 5.58701 6.1075 6.1075C5.58701 6.62799 5.58701 7.47251 6.1075 7.993L9.40739 11.2929C9.79791 11.6834 9.79791 12.3166 9.40739 12.7071L6.1075 16.007C5.58701 16.5275 5.58701 17.372 6.1075 17.8925C6.62799 18.413 7.47251 18.413 7.993 17.8925L11.2929 14.5926C11.6834 14.2021 12.3166 14.2021 12.7071 14.5926Z"
          />
        </svg>
      );
    case "companyInfo":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.47266 8H4.52344V3.77344H5.47266V8ZM4.46484 2.67578C4.46484 2.52995 4.51042 2.40885 4.60156 2.3125C4.69531 2.21615 4.82812 2.16797 5 2.16797C5.17188 2.16797 5.30469 2.21615 5.39844 2.3125C5.49219 2.40885 5.53906 2.52995 5.53906 2.67578C5.53906 2.81901 5.49219 2.9388 5.39844 3.03516C5.30469 3.12891 5.17188 3.17578 5 3.17578C4.82812 3.17578 4.69531 3.12891 4.60156 3.03516C4.51042 2.9388 4.46484 2.81901 4.46484 2.67578Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9ZM5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z"
          />
        </svg>
      );
    case "contact":
      return (
        <svg
          {...props}
          width={props.width}
          height={props.height}
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 2H1V8H9V2ZM1 1C0.447715 1 0 1.44772 0 2V8C0 8.55228 0.447716 9 1 9H9C9.55229 9 10 8.55228 10 8V2C10 1.44772 9.55228 1 9 1H1Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.07942 4.91731L0.193359 1.89482L0.8073 1.10547L4.69336 4.12796C4.87391 4.26839 5.12674 4.26839 5.3073 4.12796L9.19336 1.10547L9.8073 1.89482L5.92124 4.91731C5.37958 5.33861 4.62109 5.33861 4.07942 4.91731Z"
          />
        </svg>
      );
    case "coverage":
      return (
        <svg
          {...props}
          width={props.width}
          height={props.height}
          viewBox="0 0 10 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H8C8.82843 0.5 9.5 1.17157 9.5 2V7.70405C9.5 7.83258 9.48519 7.98895 9.42471 8.14937C9.24179 8.63458 8.87992 9.07725 8.48164 9.45566C8.0774 9.83973 7.60187 10.1891 7.14561 10.4824C6.68819 10.7764 6.23944 11.0208 5.88202 11.1931C5.70369 11.2791 5.54325 11.3495 5.41242 11.3997C5.34744 11.4246 5.28412 11.4467 5.22625 11.4634C5.18229 11.476 5.09445 11.5 5 11.5C4.90555 11.5 4.81771 11.476 4.77375 11.4634C4.71588 11.4467 4.65256 11.4246 4.58758 11.3997C4.45675 11.3495 4.29631 11.2791 4.11798 11.1931C3.76056 11.0208 3.31181 10.7764 2.85439 10.4824C2.39813 10.1891 1.9226 9.83973 1.51836 9.45566C1.12008 9.07725 0.758211 8.63459 0.575288 8.14937C0.514809 7.98895 0.5 7.83258 0.5 7.70405V2ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V7.70405C1.5 7.75872 1.50685 7.7856 1.511 7.79661C1.61726 8.07846 1.85668 8.39771 2.20715 8.73069C2.55166 9.05801 2.97233 9.36946 3.39508 9.64119C3.81667 9.91216 4.22974 10.1369 4.55229 10.2924C4.71395 10.3703 4.84804 10.4286 4.94569 10.466C4.96638 10.474 4.98446 10.4806 5 10.486C5.01554 10.4806 5.03362 10.474 5.05431 10.466C5.15196 10.4286 5.28605 10.3703 5.44771 10.2924C5.77026 10.1369 6.18333 9.91216 6.60492 9.64119C7.02767 9.36946 7.44834 9.05801 7.79285 8.73069C8.14332 8.39771 8.38274 8.07846 8.489 7.79661C8.49315 7.7856 8.5 7.75872 8.5 7.70405V2C8.5 1.72386 8.27614 1.5 8 1.5H2ZM4.93472 10.5062C4.9348 10.5062 4.93657 10.5057 4.93982 10.5051C4.93626 10.506 4.93463 10.5063 4.93472 10.5062ZM5.06017 10.5051C5.06345 10.5057 5.06522 10.5062 5.06529 10.5062C5.06535 10.5063 5.06371 10.506 5.06017 10.5051Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.53071 6.26325L6.94182 3.1066L7.73652 3.71361L4.7184 7.66495L2.54405 6.00414L3.15106 5.20944L4.53071 6.26325Z"
          />
        </svg>
      );
    case "dashboard":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              {...props}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 1.63636C0 0.732625 0.732625 0 1.63636 0H6.54545C7.44919 0 8.18182 0.732625 8.18182 1.63636V6.54545C8.18182 7.44919 7.44919 8.18182 6.54545 8.18182H1.63636C0.732625 8.18182 0 7.44919 0 6.54545V1.63636ZM1.63636 1.63636H6.54545V6.54545H1.63636L1.63636 1.63636Z"
            />
            <path
              {...props}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 11.4545C0 10.5508 0.732625 9.81818 1.63636 9.81818H6.54545C7.44919 9.81818 8.18182 10.5508 8.18182 11.4545V16.3636C8.18182 17.2674 7.44919 18 6.54545 18H1.63636C0.732625 18 0 17.2674 0 16.3636V11.4545ZM1.63636 11.4545H6.54545V16.3636H1.63636L1.63636 11.4545Z"
            />
            <path
              {...props}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.4545 9.81818C10.5508 9.81818 9.81818 10.5508 9.81818 11.4545V16.3636C9.81818 17.2674 10.5508 18 11.4545 18H16.3636C17.2674 18 18 17.2674 18 16.3636V11.4545C18 10.5508 17.2674 9.81818 16.3636 9.81818H11.4545ZM16.3636 11.4545H11.4545V16.3636H16.3636V11.4545Z"
            />
            <path
              {...props}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.81818 1.63636C9.81818 0.732625 10.5508 0 11.4545 0H16.3636C17.2674 0 18 0.732625 18 1.63636V6.54546C18 7.44919 17.2674 8.18182 16.3636 8.18182H11.4545C10.5508 8.18182 9.81818 7.44919 9.81818 6.54545V1.63636ZM11.4545 1.63636H16.3636L16.3636 6.54546L11.4545 6.54545V1.63636Z"
            />
          </g>
        </svg>
      );
    case "dash":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 22 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M2 1.57129H11H20"
            stroke="#0B0D1A"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      );
    case "date":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="2.5"
            width="24"
            height="22"
            rx="1.5"
            stroke="#E9B516"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 0.5V3H18V0.5"
            stroke="#E9B516"
            strokeLinecap="round"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 4C0 2.89543 0.895431 2 2 2H23C24.1046 2 25 2.89543 25 4V8H0V4Z"
          />
          <rect x="4" y="11" width="3" height="3" rx="0.5" fill="#E9B516" />
          <rect x="11" y="11" width="3" height="3" rx="0.5" fill="#E9B516" />
          <rect x="18" y="11" width="3" height="3" rx="0.5" fill="#E9B516" />
        </svg>
      );
    case "deadline":
      return (
        <svg
          {...props}
          width={props.width}
          height={props.height}
          viewBox="0 0 11 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 11.1172C7.20914 11.1172 9 9.32633 9 7.11719C9 4.90805 7.20914 3.11719 5 3.11719C2.79086 3.11719 1 4.90805 1 7.11719C1 9.32633 2.79086 11.1172 5 11.1172ZM5 12.1172C7.76142 12.1172 10 9.87861 10 7.11719C10 4.35576 7.76142 2.11719 5 2.11719C2.23858 2.11719 0 4.35576 0 7.11719C0 9.87861 2.23858 12.1172 5 12.1172Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.5 6.11719V4.11719H5.5V6.11719C5.5 6.39333 5.72386 6.61719 6 6.61719H7.5V7.61719H6C5.17157 7.61719 4.5 6.94561 4.5 6.11719Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5 1V3H4.5V1H5.5Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.91603 1.83984L2.91603 3.33984L2.08398 3.89454L1.08398 2.39454L1.91603 1.83984Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.40538 1.66191L0.673352 2.88668L0.0959857 2.0702L1.82801 0.845421L2.40538 1.66191Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.58397 1.83984L7.58397 3.33984L8.41602 3.89454L9.41602 2.39454L8.58397 1.83984Z"
          />
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.09462 1.66191L9.82665 2.88668L10.404 2.0702L8.67199 0.845421L8.09462 1.66191Z"
          />
        </svg>
      );
    case "edit":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M0 15.25V19H3.75L14.81 7.94L11.06 4.19L0 15.25ZM17.71 5.04C18.1 4.65 18.1 4.02 17.71 3.63L15.37 1.29C14.98 0.899998 14.35 0.899998 13.96 1.29L12.13 3.12L15.88 6.87L17.71 5.04Z"
          />
        </svg>
      );

    case "filter":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M9.33333 16H14.6667V13.3333H9.33333V16ZM0 0V2.66667H24V0H0ZM4 9.33333H20V6.66667H4V9.33333Z"
          />
        </svg>
      );
    case "info":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M14.6667 0C6.57914 0 0 6.57914 0 14.6667C0 22.7542 6.57914 29.3333 14.6667 29.3333C22.7542 29.3333 29.3333 22.7542 29.3333 14.6667C29.3333 6.57914 22.7542 0 14.6667 0Z"
          />
          <rect x="13" y="6" width="3" height="12" rx="1.5" fill="#171926" />
          <rect x="13" y="21" width="3" height="3" rx="1.5" fill="#171926" />
        </svg>
      );

    case "search":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            d="M15.7143 13.8286H14.7086L14.3315 13.4514C15.5886 12.0686 16.3429 10.1829 16.3429 8.17143C16.3429 3.64571 12.6971 0 8.17143 0C3.64571 0 0 3.64571 0 8.17143C0 12.6971 3.64571 16.3429 8.17143 16.3429C10.1829 16.3429 12.0686 15.5886 13.4514 14.3314L13.8286 14.7085V15.7142L20.1143 22L22 20.1143L15.7143 13.8286ZM8.17143 13.8286C5.02857 13.8286 2.51429 11.3143 2.51429 8.17143C2.51429 5.02857 5.02857 2.51429 8.17143 2.51429C11.3143 2.51429 13.8286 5.02857 13.8286 8.17143C13.8286 11.3143 11.3143 13.8286 8.17143 13.8286Z"
          />
        </svg>
      );

    case "settings":
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            {...props}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.6227 8.11198C19.7354 8.12922 19.8264 8.18354 19.8961 8.27485C19.9657 8.36606 20.0002 8.4679 20 8.58073V11.4711C20 11.5752 19.9655 11.6751 19.8961 11.7708C19.8268 11.8663 19.7397 11.9228 19.6357 11.9403L17.2269 12.3046C17.0619 12.7734 16.8926 13.1683 16.719 13.4895C17.0229 13.9236 17.4874 14.5224 18.1121 15.2865C18.1992 15.3903 18.2424 15.499 18.2424 15.6121C18.2424 15.7248 18.2033 15.8245 18.1253 15.9113C17.8911 16.2327 17.4615 16.7015 16.8362 17.3177C16.2113 17.9342 15.8034 18.2421 15.6125 18.2421C15.5085 18.2421 15.3955 18.2033 15.2741 18.1252L13.477 16.7187C13.0951 16.9184 12.7001 17.0834 12.2921 17.2138C12.1532 18.3943 12.0275 19.2015 11.9148 19.6354C11.8539 19.8786 11.6978 20 11.4456 20H8.55503C8.43353 20 8.32708 19.9635 8.23601 19.8895C8.14498 19.8155 8.09508 19.7222 8.08628 19.6095L7.72174 17.2138C7.29641 17.0747 6.90588 16.9141 6.54978 16.7318L4.71368 18.1252C4.62693 18.2033 4.51843 18.2421 4.38813 18.2421C4.26673 18.2421 4.15818 18.1945 4.06264 18.099C2.9688 17.1095 2.25267 16.3803 1.91413 15.9113C1.85343 15.8245 1.82305 15.7248 1.82305 15.6121C1.82305 15.5078 1.85771 15.4083 1.92727 15.3124C2.05734 15.1301 2.2789 14.8417 2.59135 14.4465C2.90385 14.0515 3.13823 13.7456 3.29438 13.5285C3.05996 13.0946 2.88205 12.6651 2.7606 12.2398L0.377627 11.8882C0.264749 11.871 0.173672 11.8164 0.104167 11.7252C0.0346614 11.6341 0 11.5323 0 11.4193V8.5286C0 8.42462 0.0346614 8.32469 0.104303 8.22928C0.173809 8.13378 0.256221 8.07728 0.351676 8.05985L2.77364 7.69536C2.89505 7.29612 3.0643 6.89674 3.28134 6.49749C2.93409 6.00248 2.46958 5.4037 1.88804 4.70044C1.80125 4.59641 1.75793 4.49225 1.75793 4.38799C1.75793 4.3012 1.79687 4.20132 1.87505 4.08849C2.10094 3.77612 2.52823 3.30961 3.15761 2.68881C3.78699 2.06814 4.19709 1.75783 4.38804 1.75783C4.50087 1.75783 4.61371 1.8012 4.72654 1.88799L6.52341 3.28124C6.90533 3.08162 7.30029 2.91671 7.70833 2.78627C7.84716 1.60569 7.97308 0.798396 8.08596 0.364537C8.14666 0.121452 8.30296 0 8.55471 0H11.4453C11.567 0 11.6731 0.0367593 11.7644 0.110643C11.8555 0.184435 11.9055 0.277792 11.9142 0.390624L12.2788 2.78632C12.704 2.92519 13.0946 3.08577 13.4506 3.26815L15.2995 1.8749C15.3776 1.79683 15.4817 1.75783 15.612 1.75783C15.7247 1.75783 15.8336 1.8012 15.9373 1.88799C17.0572 2.92104 17.7734 3.65882 18.0857 4.10158C18.1467 4.17113 18.1768 4.26654 18.1768 4.38799C18.1768 4.49225 18.1423 4.59199 18.0729 4.68749C17.9425 4.86987 17.7212 5.15838 17.4088 5.55338C17.0963 5.94848 16.862 6.25441 16.706 6.47141C16.9316 6.90554 17.1096 7.33078 17.2398 7.74749L19.6227 8.11198ZM10 15.3846C12.9739 15.3846 15.3846 12.9738 15.3846 10C15.3846 7.02616 12.9739 4.61538 10 4.61538C7.02617 4.61538 4.61539 7.02616 4.61539 10C4.61539 12.9738 7.02617 15.3846 10 15.3846Z"
          />
        </svg>
      );

    //NEW
    case "edit":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 20 19.417"
        >
          <defs>
            <style></style>
          </defs>
          <path
            fill={props.fill}
            d="M7.625,10c2.6-2.5,5.142-5.108,7.708-7.667.083-.092.175-.167.233-.225l2.35,2.3c-.1.117-.2.225-.308.333l-8.442,8.4a1.667,1.667,0,0,1-.683.408c-.908.267-1.833.5-2.792.758a1.667,1.667,0,0,1,0-.292c.125-.492.3-.967.375-1.458A4.575,4.575,0,0,1,7.625,10ZM17.733,0,16.067,1.667l2.267,2.208L20,2.25Zm-.5,9.65a.942.942,0,0,0-.917.975V17.5H1.9V3.1h8.333a.95.95,0,1,0,0-1.9H.95A.95.95,0,0,0,0,2.15V18.467H0a.95.95,0,0,0,.95.95H17.267a.95.95,0,0,0,.95-.95v-7.9a.95.95,0,0,0-.983-.917Z"
          />
        </svg>
      );

    case "edit2":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 20 19.417"
        >
          <defs>
            <style></style>
          </defs>
          <path
            fill={props.fill}
            d="M7.625,10c2.6-2.5,5.142-5.108,7.708-7.667.083-.092.175-.167.233-.225l2.35,2.3c-.1.117-.2.225-.308.333l-8.442,8.4a1.667,1.667,0,0,1-.683.408c-.908.267-1.833.5-2.792.758a1.667,1.667,0,0,1,0-.292c.125-.492.3-.967.375-1.458A4.575,4.575,0,0,1,7.625,10ZM17.733,0,16.067,1.667l2.267,2.208L20,2.25Zm-.5,9.65a.942.942,0,0,0-.917.975V17.5H1.9V3.1h8.333a.95.95,0,1,0,0-1.9H.95A.95.95,0,0,0,0,2.15V18.467H0a.95.95,0,0,0,.95.95H17.267a.95.95,0,0,0,.95-.95v-7.9a.95.95,0,0,0-.983-.917Z"
          />
        </svg>
      );
    case "iconos_compras":
      return (
        <svg
          id="Capa_1"
          data-name="Capa 1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 22.97 22.25"
        >
          <title>iconos</title>
          <path
            fill={props.fill}
            d="M21.06,17.37l0-2.86a.34.34,0,0,0-.11-.25l-3.89-4a.32.32,0,0,0-.17-.09L16.8,4.63a.32.32,0,0,1,.08-.2L20.39.8a.47.47,0,0,0,0-.67.46.46,0,0,0-.65,0L15.91,4a.27.27,0,0,0-.09.2L16,21a.24.24,0,0,1-.24.24L.49,21.18a.48.48,0,0,0-.49.48.49.49,0,0,0,.49.49l16.22.1A.24.24,0,0,0,17,22l-.09-10.56L20,14.64a.39.39,0,0,1,.1.27v2.43a2.35,2.35,0,0,0-1.22.65,2.57,2.57,0,0,0-.69,1.76v0a2.47,2.47,0,0,0,2.45,2.48,2.32,2.32,0,0,0,1.67-.69A2.54,2.54,0,0,0,23,19.8h0A2.46,2.46,0,0,0,21.06,17.37Zm.49,3.51a1.22,1.22,0,0,1-1,.44,1.49,1.49,0,0,1-1-.44,1.52,1.52,0,0,1,0-2.16,1.41,1.41,0,0,1,1-.44h.12A1.4,1.4,0,0,1,22,19.8,1.48,1.48,0,0,1,21.55,20.88ZM1,19.66l12.8.13a.56.56,0,0,0,.57-.57L14.26,6.71a.78.78,0,0,0-.78-.78L1.19,5.84a.79.79,0,0,0-.79.79L.53,19.21A.46.46,0,0,0,1,19.66Zm8-6.34a.14.14,0,0,1-.21.12L7.47,12.6a.14.14,0,0,0-.15,0l-1.23.79a.13.13,0,0,1-.21-.11l0-6.47,3.08,0ZM1.6,6.77l3.21,0,.09,8.34a.13.13,0,0,0,.21.11l2.21-1.47a.14.14,0,0,1,.15,0l2.26,1.51a.13.13,0,0,0,.21-.11L9.86,6.84l3.2,0a.22.22,0,0,1,.22.22l.09,11.27a.46.46,0,0,1-.46.46l-11-.09a.46.46,0,0,1-.44-.45L1.37,7A.23.23,0,0,1,1.6,6.77Z"
          />
        </svg>
      );
    case "iconos_egresos":
      return (
        <svg
          id="Capa_1"
          data-name="Capa 1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 22.37 18.86"
        >
          <title>iconos</title>
          <path
            fill={props.fill}
            d="M22.09,4.1,11.71.13a.57.57,0,0,0-.18,0,.54.54,0,0,0-.25.06L8.13,2l0,.06a4.42,4.42,0,1,0-3.9,6.76V14.4a.5.5,0,0,0,.31.46l10.36,4a.43.43,0,0,0,.17,0,.4.4,0,0,0,.23-.06l6.79-4a.46.46,0,0,0,.24-.41V4.58A.48.48,0,0,0,22.09,4.1ZM.93,4.42a3.5,3.5,0,1,1,3.49,3.5A3.5,3.5,0,0,1,.93,4.42ZM4.57,8.84h0Zm10.08,8.81-9.4-3.59V8.77h0A4.43,4.43,0,0,0,8.38,6.4l0,0,6.3,2.42ZM15.07,8,8.7,5.54h0a4.67,4.67,0,0,0,.15-1.13,4.5,4.5,0,0,0-.29-1.56v0l3-1.76L20.8,4.65,18.45,6,15.1,4.73a.46.46,0,0,0-.6.29.47.47,0,0,0,.26.6l2.62,1ZM8.54,6a.14.14,0,0,0,0-.06A.14.14,0,0,1,8.54,6ZM8.36,2.41l0,.07ZM21.44,14.13l-5.83,3.41V8.83L18.05,7.4v2.9a.47.47,0,0,0,.13.36.49.49,0,0,0,.34.15.47.47,0,0,0,.35-.13.49.49,0,0,0,.15-.34V6.82l2.42-1.4Zm-14.92-9H2.33a.47.47,0,1,1,0-.93H6.52a.47.47,0,1,1,0,.93ZM8,8.72l4.31,1.65a.48.48,0,0,1,.28.62.5.5,0,0,1-.45.3.52.52,0,0,1-.18,0L7.61,9.62A.51.51,0,0,1,7.33,9,.5.5,0,0,1,8,8.72ZM12.55,14a.5.5,0,0,1-.45.3.52.52,0,0,1-.18,0L7.57,12.57a.43.43,0,0,1-.25-.26A.48.48,0,0,1,8,11.69l4.31,1.65A.48.48,0,0,1,12.55,14Z"
          />
        </svg>
      );
    case "iconos_ingresos":
      return (
        <svg
          id="Capa_1"
          data-name="Capa 1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 22.49 18.96"
        >
          <title>iconos</title>
          <path
            fill={props.fill}
            d="M8,8.77l4.33,1.65a.49.49,0,0,1,.28.62.5.5,0,0,1-.45.31l-.18,0L7.65,9.67A.51.51,0,0,1,7.37,9,.49.49,0,0,1,8,8.77Zm4.34,4.64L8,11.75a.48.48,0,0,0-.2,0,.39.39,0,0,0-.18,0,.46.46,0,0,0-.26.25.52.52,0,0,0,0,.37.49.49,0,0,0,.26.27L12,14.31l.18,0a.51.51,0,0,0,.45-.31A.48.48,0,0,0,12.34,13.41Zm10.15-8.8v9.88a.47.47,0,0,1-.25.41l-6.82,4a.49.49,0,0,1-.23.06,1,1,0,0,1-.18,0l-10.41-4a.51.51,0,0,1-.3-.47V8.89h.15a4.58,4.58,0,0,0,.83-.08v5.32l9.45,3.61V8.92L8.4,6.49a4.85,4.85,0,0,0,.35-.92L15.15,8l2.32-1.38-2.63-1a.48.48,0,0,1-.27-.6.48.48,0,0,1,.61-.3l3.36,1.3,2.37-1.37L11.65,1.13l-3,1.76A4.61,4.61,0,0,0,8.18,2L11.34.16A.54.54,0,0,1,11.59.1a.57.57,0,0,1,.18,0l10.43,4A.48.48,0,0,1,22.49,4.61Zm-.94.83L19.12,6.86v3.53a.51.51,0,0,1-.15.35.47.47,0,0,1-.36.13.5.5,0,0,1-.34-.16.49.49,0,0,1-.13-.35V7.44L15.69,8.87v8.76l5.86-3.43ZM8.9,4.45A4.45,4.45,0,1,0,4.45,8.9,4.46,4.46,0,0,0,8.9,4.45ZM8,4.45A3.51,3.51,0,1,1,4.45.94,3.52,3.52,0,0,1,8,4.45ZM6.55,4.21H4.92V2.58a.47.47,0,0,0-.94,0V4.21H2.34a.47.47,0,0,0,0,.94H4V6.79a.47.47,0,0,0,.94,0V5.15H6.55a.47.47,0,0,0,0-.94Z"
          />
        </svg>
      );
    case "iconos_reposicion":
      return (
        <svg
          id="Capa_1"
          data-name="Capa 1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 24.18 22.31"
        >
          <title>iconos</title>
          <path
            fill={props.fill}
            d="M1.59,11.44a.47.47,0,0,1-.33-.14L.14,10.17a.45.45,0,0,1,0-.66.47.47,0,0,1,.66,0l.38.39A11,11,0,0,1,12.09,0h0A11,11,0,0,1,22.72,8.23a.48.48,0,0,1-.07.35.44.44,0,0,1-.3.2.46.46,0,0,1-.54-.32A10,10,0,0,0,2.14,9.76l.24-.25a.48.48,0,0,1,.67,0,.51.51,0,0,1,.13.33.47.47,0,0,1-.13.33L1.92,11.3h0a.42.42,0,0,1-.22.11l0,0H1.59Zm22.59.65a.44.44,0,0,1-.13.33.47.47,0,0,1-.24.13h-.09a.49.49,0,0,1-.33-.13L23,12.06a11,11,0,0,1-3.81,7.6.33.33,0,0,1-.14.12,10.86,10.86,0,0,1-7,2.53h0a11,11,0,0,1-7-2.57l0,0a11,11,0,0,1-3.53-5.62.45.45,0,0,1,0-.36.4.4,0,0,1,.27-.22.45.45,0,0,1,.36,0,.49.49,0,0,1,.23.28.08.08,0,0,0,0,0,9.89,9.89,0,0,0,2.5,4.45V9.84h0v0a.43.43,0,0,1,0-.16.07.07,0,0,1,0-.05L6.07,7.72a.39.39,0,0,1,.34-.21H17.72l.09,0h.06l0,0a.48.48,0,0,1,.23.17l0,0v0L19.24,9.6a.29.29,0,0,1,.05.13s0,0,0,.06V18.3a10,10,0,0,0,2.78-6.17l-.29.29a.47.47,0,0,1-.33.14h0a.45.45,0,0,1-.33-.14.44.44,0,0,1-.14-.33.47.47,0,0,1,.14-.33l1.12-1.12a.36.36,0,0,1,.15-.1.46.46,0,0,1,.51.1l1.13,1.12A.46.46,0,0,1,24.18,12.09ZM7,20a10,10,0,0,0,11.37-.83V10.31H14.06v1.78a.45.45,0,0,1-.44.46h-.14l-1.39-.35-1.38.34-.11,0h0l-.09,0a.45.45,0,0,1-.37-.45V10.31H5.81v8.85A11,11,0,0,0,7,20Zm6.13-8.5V10.31H11.06v1.18l.92-.23h.23ZM18,9.37l-.57-.94H13.77l.19.94Zm-5.2-.94H11.35l-.19.94H13Zm-2.42,0H6.73l-.56.94h4Zm5.1,8.63a.47.47,0,0,0,.45-.49.46.46,0,0,0-.48-.45H8.68a.47.47,0,0,0-.45.49.51.51,0,0,0,.15.33.47.47,0,0,0,.31.12H15.5Zm-6.81-1.5h6.78a.47.47,0,0,0,.45-.45.45.45,0,0,0-.12-.33.46.46,0,0,0-.33-.15H8.68a.46.46,0,0,0-.33.15.5.5,0,0,0-.12.33.51.51,0,0,0,.15.33A.47.47,0,0,0,8.69,15.56Zm5.36,2.55a.46.46,0,0,0-.13-.33.46.46,0,0,0-.33-.16h-3a.47.47,0,0,0-.33.16.45.45,0,0,0-.12.33.46.46,0,0,0,.46.45h3A.47.47,0,0,0,14.05,18.11Z"
          />
        </svg>
      );
    case "iconos_reubicacion":
      return (
        <svg
          id="Capa_1"
          data-name="Capa 1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 24.16 20.49"
        >
          <title>iconos</title>
          <path
            fill={props.fill}
            d="M14.34,18l.22-.11v1.39a1.19,1.19,0,0,0,1.27,1.06h6.86A1.23,1.23,0,0,0,24,19.22V6.53a3.5,3.5,0,0,0-1.64-2.82,6.47,6.47,0,0,0-.66-.4,3,3,0,0,1-.41-.26l-.17-.13.19-.11a.85.85,0,0,0,.4-.7V1A.82.82,0,0,0,20.9.15H17.66a.82.82,0,0,0-.81.82V2.1a.81.81,0,0,0,.37.68l.14.09L17.25,3a1.7,1.7,0,0,1-.49.35c-.2.12-.41.25-.63.4a3.47,3.47,0,0,0-1.57,2.8v1.3l-.22-.11a5.69,5.69,0,0,0-4.54-.3l-.2.07v-1A3.48,3.48,0,0,0,8,3.71c-.25-.17-.47-.29-.66-.4l-.41-.26-.16-.13.18-.11a.82.82,0,0,0,.4-.7V1A.82.82,0,0,0,6.49.15H3.25A.82.82,0,0,0,2.44,1V2.1a.81.81,0,0,0,.37.68L3,2.87,2.84,3a1.87,1.87,0,0,1-.49.35c-.19.11-.4.24-.63.4A3.5,3.5,0,0,0,.15,6.55V19.27a1.19,1.19,0,0,0,1.27,1.06H8.28A1.25,1.25,0,0,0,9.6,19.22v-1l.2.07A5.69,5.69,0,0,0,14.34,18Zm8.71,1.22,0,.05a.42.42,0,0,1-.29.1h-7c-.07,0-.17,0-.17-.05V17.18l0-.05A5.56,5.56,0,0,0,17,15.22l0-.08h6ZM17.83,1.13h2.91v.81H17.83ZM15.54,6.56a2.49,2.49,0,0,1,1.16-2c.17-.12.33-.22.53-.34A1.82,1.82,0,0,0,18.29,3l0-.12h1.84l0,.11a1.78,1.78,0,0,0,1,1.13,4.72,4.72,0,0,1,.61.37,2.49,2.49,0,0,1,1.2,2v.3H15.54Zm0,1.26H23v6.34H17.34l0-.18a5.29,5.29,0,0,0,.11-1.11A5.8,5.8,0,0,0,15.59,8.6l-.05,0ZM3.42,1.13H6.33v.81H3.42ZM1.13,6.56a2.49,2.49,0,0,1,1.16-2,6.11,6.11,0,0,1,.53-.34A1.84,1.84,0,0,0,3.89,3l0-.12H5.75l0,.11A1.77,1.77,0,0,0,6.82,4.16c.17.1.37.21.6.37a2.49,2.49,0,0,1,1.2,2v.3H1.13Zm0,1.26H8.9l-.41.27A5.78,5.78,0,0,0,6,12.87,5.29,5.29,0,0,0,6.07,14l0,.18h-5ZM8.6,19.26a.4.4,0,0,1-.29.1H1.21s-.09,0-.08-.07V15.14h5.3l0,.08a5.72,5.72,0,0,0,2.1,2.47l.06,0v1.48ZM6.84,12.87a4.88,4.88,0,1,1,4.88,4.88A4.89,4.89,0,0,1,6.84,12.87Zm6.22,1.73a.43.43,0,0,1,0-.62l.71-.71H8.25a.44.44,0,1,1,0-.88H13.7l-.64-.63a.44.44,0,0,1,0-.62.42.42,0,0,1,.31-.13h0a.4.4,0,0,1,.31.13l1.43,1.42a.46.46,0,0,1,.13.31.48.48,0,0,1-.13.32L13.68,14.6A.44.44,0,0,1,13.06,14.6Z"
          />
        </svg>
      );
    case "alert":
      return (
        <svg
          id="Capa_1"
          data-name="Capa 1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 24 24"
        >
          <title>iconos</title>
          <path
            fill={props.fill}
            d="M12.7,15.66H11.3V7.82h1.4ZM12,17.22a1.05,1.05,0,1,0,.94,1.05A1,1,0,0,0,12,17.22Zm12,3.64A3,3,0,0,1,21.18,24H2.83a2.59,2.59,0,0,1-1.42-.42,3.35,3.35,0,0,1-1-4.3L9.56,1.57a3,3,0,0,1,1-1.15,2.68,2.68,0,0,1,3.86,1.15l9.17,17.71A3.41,3.41,0,0,1,24,20.86Zm-1.6-.8L13.23,2.36a1.46,1.46,0,0,0-.52-.58,1.33,1.33,0,0,0-1.93.58L1.6,20.06a1.8,1.8,0,0,0-.19.79,1.5,1.5,0,0,0,1.42,1.58H21.18a1.39,1.39,0,0,0,1.22-.79A1.7,1.7,0,0,0,22.4,20.06Z"
          />
        </svg>
      );
    case "check_circle":
      return (
        <svg
          id="Capa_1"
          data-name="Capa 1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 24 24"
        >
          <title>iconos</title>
          <path
            fill={props.fill}
            d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,23.24A11.24,11.24,0,1,1,23.24,12,11.25,11.25,0,0,1,12,23.24Zm6.35-16a1.36,1.36,0,0,0-1.92,0l-6.28,6.3L7.61,11a1.38,1.38,0,0,0-.94-.39h0a1.33,1.33,0,0,0-.93.39l-1,1a1.34,1.34,0,0,0,0,1.87L9.21,18.3a1.54,1.54,0,0,0,.95.39,1.33,1.33,0,0,0,.93-.39l8.16-8.16a1.34,1.34,0,0,0,.39-1,1.28,1.28,0,0,0-.35-.89Zm.36,2.35-8.16,8.16a.46.46,0,0,1-.4.17.56.56,0,0,1-.4-.17L5.28,13.29a.55.55,0,0,1-.16-.39.6.6,0,0,1,.16-.41l1-1a.58.58,0,0,1,.4-.16h0a.59.59,0,0,1,.4.16l3.08,3.09L17,7.76a.58.58,0,0,1,.41-.15.59.59,0,0,1,.41.16l.94,1.05a.53.53,0,0,1,.15.37A.57.57,0,0,1,18.71,9.6Z"
          />
        </svg>
      );

    case "documento":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          className={className}
          viewBox={`0 0 ${props.width ?? 21.922} ${props.height ?? 27.267}`}
        >
          <g id="Ordenes" transform="translate(0.25 0.25)">
            <path
              id="iconos_documento"
              data-name="iconos documento"
              d="M-2504.391-1821.432l-5.142-5.153-.49-.5h-12.915a2.34,2.34,0,0,0-2.354,2.325v22.089a2.339,2.339,0,0,0,2.325,2.354h16.758a2.339,2.339,0,0,0,2.339-2.339v-18.217Zm-5.019-3.848,3.71,3.77h-2.951a.769.769,0,0,1-.759-.747Zm3.226,24.124h-16.732a1.505,1.505,0,0,1-1.527-1.484c0-.011,0-.022,0-.033v-22.06a1.506,1.506,0,0,1,1.495-1.517h12.569l.134.134v3.814a1.6,1.6,0,0,0,1.595,1.594h3.781l.189.19v17.844a1.506,1.506,0,0,1-1.494,1.517h-.008Zm-16.027-20.781a.394.394,0,0,1,.361-.421h9.265a.4.4,0,0,1,.36.424.4.4,0,0,1-.36.424h-9.286a.4.4,0,0,1-.342-.423Zm15.336,11.29a.4.4,0,0,1-.391.4h-14.584a.389.389,0,0,1-.436-.352.42.42,0,0,1,.316-.485.358.358,0,0,1,.12,0h14.614a.4.4,0,0,1,.363.422v.013Zm0-5.3a.4.4,0,0,1-.391.4h-14.584a.388.388,0,0,1-.436-.352.42.42,0,0,1,.316-.484.334.334,0,0,1,.12,0h14.614a.4.4,0,0,1,.363.422v.013Zm0,10.858a.4.4,0,0,1-.391.4h-14.584a.4.4,0,0,1-.368-.427.4.4,0,0,1,.383-.41h14.6a.408.408,0,0,1,.365.439.359.359,0,0,1,0,.04Z"
              transform="translate(2525.292 1827.087)"
              fill={props.fill}
              stroke={props.fill}
              strokeWidth="0.3"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
    case "chevron":
      return (
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 24 24"
        >
          <path
            fill={props.fill}
            d="M2.1,17.6l-2.1-2.1L12,3.4l12,12l-2.1,2.1L12,7.6L2.1,17.6z"
          />
        </svg>
      );
    case "trash_can":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 11.314 14"
        >
          <defs></defs>
          <path
            fill={props.fill}
            d="M9.769,12.255a.525.525,0,0,1,0-.136V8.354a.956.956,0,0,1,0-.13.349.349,0,0,1,.7.024v3.931a.348.348,0,0,1-.313.378.537.537,0,0,1-.136,0,.325.325,0,0,1-.248-.3Zm3.022-7.325a.177.177,0,0,0-.106.195v7.384A1.529,1.529,0,0,1,11.752,14a1.582,1.582,0,0,1-.655.148h-6.1A1.594,1.594,0,0,1,3.4,12.562V5.149a.212.212,0,0,0-.142-.236A1.641,1.641,0,0,1,2.45,3.1a1.564,1.564,0,0,1,1.4-1.269c.549-.03,1.11,0,1.664,0h.59a.1.1,0,0,0,.118-.094A1.871,1.871,0,0,1,7.8.15h.478a4.657,4.657,0,0,1,.726.266,1.771,1.771,0,0,1,.915,1.293c0,.1.053.124.148.124h1.995a1.6,1.6,0,0,1,1.611,1.239A1.641,1.641,0,0,1,12.791,4.931ZM6.983,1.8H9.161A1.1,1.1,0,0,0,7.98.9a1.056,1.056,0,0,0-1,.9ZM11.947,5.1H4.179v7.354a.832.832,0,0,0,.755.909.667.667,0,0,0,.153,0H11.02a1.251,1.251,0,0,0,.26,0,.844.844,0,0,0,.649-.879V5.1Zm1.027-1.635a.909.909,0,0,0-.059-.331.85.85,0,0,0-.862-.59H4.067a.814.814,0,0,0-.773.466.909.909,0,0,0,0,.938.868.868,0,0,0,.82.413h7.98a.879.879,0,0,0,.879-.9ZM8.1,12.55a.348.348,0,0,0,.313-.384V8.212a.36.36,0,0,0-.4-.307.366.366,0,0,0-.3.407v3.925a.348.348,0,0,0,.39.313Zm-2.4-.319a.342.342,0,0,0,.667.106.879.879,0,0,0,.03-.212v-3.8a1.245,1.245,0,0,0,0-.148A.336.336,0,0,0,6.1,7.9a.118.118,0,0,0-.065,0,.342.342,0,0,0-.319.366v3.813A1.133,1.133,0,0,0,5.708,12.232Z"
            transform="translate(-2.407 -0.15)"
          />
        </svg>
      );
    case "remove":
      return (
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.34424 1L10.0002 9.656"
            stroke="#676F8F"
            stroke-width="0.973022"
            stroke-linecap="round"
          />
          <path
            d="M10.0002 1L1.34424 9.656"
            stroke="#676F8F"
            stroke-width="0.973022"
            stroke-linecap="round"
          />
        </svg>
      );
    case "barcode":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 30.967 24.773"
          fill={props.fill}
        >
          <defs></defs>
          <g transform="translate(0 -48)">
            <g transform="translate(0 48)">
              <path
                d="M5.161,48H1.032A1.033,1.033,0,0,0,0,49.032v4.129a1.032,1.032,0,0,0,2.064,0v-3.1h3.1a1.032,1.032,0,0,0,0-2.064Z"
                transform="translate(0 -48)"
              />
            </g>
            <g transform="translate(24.773 66.58)">
              <path
                fill={props.fill}
                d="M389.161,336a1.033,1.033,0,0,0-1.032,1.032v3.1h-3.1a1.032,1.032,0,0,0,0,2.064h4.129a1.033,1.033,0,0,0,1.032-1.032v-4.129A1.033,1.033,0,0,0,389.161,336Z"
                transform="translate(-384 -336)"
              />
            </g>
            <g transform="translate(24.773 48)">
              <path
                fill={props.fill}
                d="M389.161,48h-4.129a1.032,1.032,0,0,0,0,2.064h3.1v3.1a1.032,1.032,0,0,0,2.064,0V49.032A1.033,1.033,0,0,0,389.161,48Z"
                transform="translate(-384 -48)"
              />
            </g>
            <g transform="translate(0 66.58)">
              <path
                fill={props.fill}
                d="M5.161,340.129h-3.1v-3.1a1.032,1.032,0,0,0-2.064,0v4.129a1.033,1.033,0,0,0,1.032,1.032H5.161a1.032,1.032,0,0,0,0-2.064Z"
                transform="translate(0 -336)"
              />
            </g>
            <g transform="translate(4.129 52.129)">
              <rect
                width="2"
                height="17"
                transform="translate(-0.129 -0.129)"
              />
            </g>
            <g transform="translate(8.258 52.129)">
              <rect
                width="2"
                height="13"
                transform="translate(-0.258 -0.129)"
              />
            </g>
            <g transform="translate(12.387 52.129)">
              <rect
                width="2"
                height="13"
                transform="translate(-0.387 -0.129)"
              />
            </g>
            <g transform="translate(16.516 52.129)">
              <rect width="2" height="17" transform="translate(0.484 -0.129)" />
            </g>
            <g transform="translate(20.645 52.129)">
              <rect width="2" height="13" transform="translate(0.355 -0.129)" />
            </g>
            <g transform="translate(24.773 52.129)">
              <rect width="2" height="17" transform="translate(0.227 -0.129)" />
            </g>
            <g transform="translate(8.258 66.58)">
              <rect width="2" height="2" transform="translate(-0.258 0.42)" />
            </g>
            <g transform="translate(12.387 66.58)">
              <rect width="2" height="2" transform="translate(-0.387 0.42)" />
            </g>
            <g transform="translate(20.645 66.58)">
              <rect width="2" height="2" transform="translate(0.355 0.42)" />
            </g>
          </g>
        </svg>
      );
    case "cerrar-sesion":
      return (
        <svg
          id="Cerrar_sesión"
          data-name="Cerrar sesión"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 28.292 27.062"
        >
          <g
            id="Grupo_14627"
            data-name="Grupo 14627"
            transform="translate(0 12.916)"
          >
            <path
              {...props}
              id="Trazado_13848"
              data-name="Trazado 13848"
              d="M483.09,39.221h18.451a.615.615,0,1,1,0,1.229H483.09a.615.615,0,1,1,0-1.229Z"
              transform="translate(-482.475 -39.221)"
              fill="#fff"
            />
          </g>
          <g
            id="Grupo_14628"
            data-name="Grupo 14628"
            transform="translate(13.532 7.996)"
          >
            <path
              {...props}
              id="Trazado_13849"
              data-name="Trazado 13849"
              d="M496.088,34.494a.621.621,0,0,1,.436.179l4.92,4.921a.615.615,0,0,1,0,.87l-4.92,4.921a.615.615,0,0,1-.87-.87l4.485-4.484-4.485-4.485a.616.616,0,0,1,0-.869A.609.609,0,0,1,496.088,34.494Z"
              transform="translate(-495.474 -34.494)"
              fill="#fff"
            />
          </g>
          <g
            id="Grupo_14629"
            data-name="Grupo 14629"
            transform="translate(1.967 0)"
          >
            <path
              {...props}
              id="Trazado_13850"
              data-name="Trazado 13850"
              d="M497.158,26.813A13.531,13.531,0,1,1,484.4,44.855a.615.615,0,0,1,1.16-.41,12.3,12.3,0,1,0,0-8.2.615.615,0,0,1-1.16-.41A13.545,13.545,0,0,1,497.158,26.813Z"
              transform="translate(-484.365 -26.813)"
              fill="#fff"
            />
          </g>
        </svg>
      );
    case "configuraciones":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          className={className}
          viewBox={`0 0 ${props.width ?? 27.92} ${props.height ?? 27.919}`}
        >
          <g id="Configuracion" transform="translate(0.75 0.75)">
            <g
              id="Grupo_14685"
              data-name="Grupo 14685"
              transform="translate(0 0)"
            >
              <path
                id="Trazado_8"
                data-name="Trazado 8"
                d="M1085.333,1600.111a2.227,2.227,0,0,1,2.872-.9,13.267,13.267,0,0,0,.661-2.472,2.222,2.222,0,0,1,0-4.429,13.249,13.249,0,0,0-.661-2.474,2.222,2.222,0,0,1-2.2-3.843,13.561,13.561,0,0,0-1.813-1.814,2.223,2.223,0,0,1-3.844-2.205,13.284,13.284,0,0,0-2.473-.66,2.223,2.223,0,0,1-4.429,0,13.288,13.288,0,0,0-2.473.66,2.223,2.223,0,0,1-3.844,2.205,13.473,13.473,0,0,0-1.812,1.814,2.222,2.222,0,0,1-2.205,3.843,13.306,13.306,0,0,0-.661,2.474,2.222,2.222,0,0,1,0,4.429,13.324,13.324,0,0,0,.661,2.472,2.223,2.223,0,0,1,2.205,3.843,13.451,13.451,0,0,0,1.812,1.813,2.223,2.223,0,0,1,3.844,2.205,13.3,13.3,0,0,0,2.473.661,2.223,2.223,0,0,1,4.429,0,13.294,13.294,0,0,0,2.473-.661,2.223,2.223,0,0,1,3.844-2.205,13.538,13.538,0,0,0,1.813-1.813A2.227,2.227,0,0,1,1085.333,1600.111Z"
                transform="translate(-1062.447 -1581.315)"
                fill="none"
                stroke={props.fill ?? "none"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <ellipse
                id="Elipse_1"
                data-name="Elipse 1"
                cx="4.469"
                cy="4.469"
                rx="4.469"
                ry="4.469"
                transform="translate(8.741 8.741)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
            </g>
          </g>
        </svg>
      );
    case "contactos":
      return (
        <svg
          id="Capa_1"
          fill={props.fill}
          data-name="Capa 1"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 18.86 18.86"
        >
          <path
            fill={props.fill}
            d="M12.28,5a4.42,4.42,0,1,0,4.41,4.41A4.42,4.42,0,0,0,12.28,5Zm0,8.36a3.93,3.93,0,0,1-2.06-.58,2.09,2.09,0,0,1,4.12,0A3.93,3.93,0,0,1,12.28,13.38ZM10.65,9a1.63,1.63,0,1,1,1.63,1.62A1.63,1.63,0,0,1,10.65,9Zm4.1,3.54a2.56,2.56,0,0,0-1.46-1.71A2.11,2.11,0,0,0,14.37,9a2.09,2.09,0,1,0-4.18,0,2.11,2.11,0,0,0,1.08,1.83A2.57,2.57,0,0,0,9.8,12.51a4,4,0,1,1,4.95,0Z"
          />
          <path d="M17.34,0H3.42A1.52,1.52,0,0,0,1.9,1.52v1H1.2a1.21,1.21,0,0,0,0,2.41h.7V6.33H1.2a1.21,1.21,0,0,0,0,2.41h.7v1.7H1.2a1.21,1.21,0,0,0,0,2.41h.7v1.39H1.2a1.21,1.21,0,0,0,0,2.41h.7v.69a1.52,1.52,0,0,0,1.52,1.52H17.34a1.52,1.52,0,0,0,1.52-1.52V1.52A1.52,1.52,0,0,0,17.34,0ZM1.2,4.43A.7.7,0,0,1,1.2,3H3.1a.7.7,0,1,1,0,1.39Zm0,3.8a.7.7,0,0,1,0-1.39H3.1a.7.7,0,1,1,0,1.39Zm0,4.11A.7.7,0,0,1,1.2,11H3.1a.7.7,0,1,1,0,1.39Zm0,3.8a.7.7,0,0,1,0-1.39H3.1a.7.7,0,1,1,0,1.39Zm4.5,2.21H3.42a1,1,0,0,1-1-1v-.69H3.1a1.21,1.21,0,1,0,0-2.41H2.41V12.85H3.1a1.21,1.21,0,1,0,0-2.41H2.41V8.74H3.1a1.21,1.21,0,1,0,0-2.41H2.41V4.94H3.1a1.21,1.21,0,1,0,0-2.41H2.41v-1a1,1,0,0,1,1-1H5.7Zm12.65-1a1,1,0,0,1-1,1H6.2V.51H17.34a1,1,0,0,1,1,1Z" />
        </svg>
      );
    case "reportes":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 30.708 23.288"
        >
          <g id="Reportes" transform="translate(-74 -465)">
            <g
              id="Grupo_14759"
              data-name="Grupo 14759"
              transform="translate(326.038 99.201)"
            >
              <path
                {...props}
                id="Trazado_13910"
                data-name="Trazado 13910"
                d="M-249.963,373.646v7.933h-2.075v1.279h30.708v-1.279h-2.078v-11.05a.641.641,0,0,0-.639-.639h-5.627a.641.641,0,0,0-.639.64v11.049h-2.918V366.438a.64.64,0,0,0-.639-.639h-5.63a.64.64,0,0,0-.639.639v15.141h-2.918v-7.934a.64.64,0,0,0-.639-.639h-5.628A.642.642,0,0,0-249.963,373.646Zm20.928-2.482h4.35v10.415h-4.35Zm-9.824-4.085h4.351v14.5h-4.35v-14.5Zm-9.825,7.2h4.351v7.3h-4.351Z"
                fill="#fff"
              />
              <rect
                id="Rectángulo_24472"
                data-name="Rectángulo 24472"
                width="8.094"
                height="1.279"
                transform="translate(-252.038 387.808)"
                fill="#fff"
              />
              <rect
                id="Rectángulo_24473"
                data-name="Rectángulo 24473"
                width="17.917"
                height="1.279"
                transform="translate(-239.248 387.808)"
                fill="#fff"
              />
            </g>
          </g>
        </svg>
      );
    case "account":
      return (
        <svg
          className={styles["Mi_cuenta"]}
          data-name="Mi cuenta"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 27.87 27.87"
        >
          <g id="Grupo_14626" data-name="Grupo 14626" transform="translate(0)">
            <g id="Grupo_14623" data-name="Grupo 14623">
              <path
                {...props}
                id="Trazado_13847"
                data-name="Trazado 13847"
                d="M446.465,41.209A13.935,13.935,0,1,0,432.53,55.144,13.951,13.951,0,0,0,446.465,41.209ZM432.53,53.677a12.389,12.389,0,0,1-6.507-1.837,6.6,6.6,0,0,1,13.015,0A12.393,12.393,0,0,1,432.53,53.677ZM427.4,39.742a5.134,5.134,0,1,1,5.134,5.135A5.14,5.14,0,0,1,427.4,39.742Zm12.945,11.179a8.073,8.073,0,0,0-4.634-5.394,6.6,6.6,0,1,0-6.353,0,8.07,8.07,0,0,0-4.634,5.394,12.467,12.467,0,1,1,15.621,0Z"
                transform="translate(-418.595 -27.274)"
                fill="#fff"
              />
            </g>
          </g>
        </svg>
      );
    case "sucursal":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 20.797 23.651"
        >
          <path
            {...props}
            id="Trazado_14635"
            data-name="Trazado 14635"
            d="M2257.455,642.751l-2.848-5.713a.61.61,0,0,0-.54-.335h-13.876a.606.606,0,0,0-.544.336l-2.852,5.707a.6.6,0,0,0-.069.274l0,3.264a3.067,3.067,0,0,0,1.631,2.7v10.762a.611.611,0,0,0,.609.609h5.71a.609.609,0,0,0,.607-.609v-5.1h3.679v5.1a.61.61,0,0,0,.608.609h5.71a.611.611,0,0,0,.609-.609V648.983a3.073,3.073,0,0,0,1.631-2.7v-3.265A.6.6,0,0,0,2257.455,642.751Zm-19.136-.337,2.248-4.495h13.117l2.247,4.495Zm17.989,1.215v2.655a1.84,1.84,0,0,1-3.679,0v-2.655Zm-6.736,9.8h-4.893a.61.61,0,0,0-.609.608v5.1h-4.5v-9.809a3.006,3.006,0,0,0,2.654-1.218,22.623,22.623,0,0,1,8.9.8,3.076,3.076,0,0,0,.89-.8,2.987,2.987,0,0,0,2.657,1.218v9.809h-4.494v-5.1A.61.61,0,0,0,2249.572,653.429Zm-3.054-7.145a1.839,1.839,0,0,1-3.679,0v-2.655h3.679Zm4.894,0a1.84,1.84,0,0,1-3.679,0v-2.655h3.679Zm-9.789,0a1.839,1.839,0,0,1-3.679,0v-2.655h3.679Z"
            transform="translate(-2236.726 -636.703)"
          />
        </svg>
      );

    case "sucursal-azul":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 23.811 27"
        >
          <path
            id="Trazado_14636"
            data-name="Trazado 14636"
            d="M2298.193,643.976,2295,637.6a.951.951,0,0,0-.855-.538H2278.64a.954.954,0,0,0-.856.528l-3.185,6.372a.942.942,0,0,0-.112.438l0,3.653a3.716,3.716,0,0,0,1.825,3.181V663.1a.957.957,0,0,0,.955.956h6.387a.957.957,0,0,0,.956-.956v-5.431h3.561V663.1a.957.957,0,0,0,.956.956h6.386a.957.957,0,0,0,.956-.956V651.229a3.714,3.714,0,0,0,1.825-3.181v-3.655A.939.939,0,0,0,2298.193,643.976Zm-4.634-5.006,2.236,4.473h-18.8l2.237-4.473Zm-11.682,9.081v-2.694h3.561v2.683a1.784,1.784,0,0,1-1.781,1.744h-.037A1.772,1.772,0,0,1,2281.877,648.051Zm5.474,0v-2.694h3.561v2.683a1.766,1.766,0,0,1-.548,1.248,1.7,1.7,0,0,1-1.269.495A1.774,1.774,0,0,1,2287.351,648.051Zm-10.948-2.694h3.561v2.683a1.784,1.784,0,0,1-1.78,1.744h-.038a1.773,1.773,0,0,1-1.743-1.732Zm6.3,11.362v5.429h-4.474V651.742a3.613,3.613,0,0,0,2.7-1.214,3.691,3.691,0,0,0,4.618.7,3.768,3.768,0,0,0,.852-.7,3.69,3.69,0,0,0,4.621.7,3.739,3.739,0,0,0,.85-.7,3.614,3.614,0,0,0,2.7,1.214v10.406h-4.47v-5.429a.957.957,0,0,0-.956-.956h-5.477A.957.957,0,0,0,2282.7,656.719Zm10.123-8.668v-2.694h3.561v2.688a1.784,1.784,0,0,1-1.781,1.739h-.037A1.773,1.773,0,0,1,2292.825,648.051Z"
            transform="translate(-2274.487 -637.058)"
            fill="#3c7af5"
          />
        </svg>
      );
    case "dispositivos":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="36"
          viewBox="0 0 38 36"
        >
          <g
            id="Mesa_de_trabajo_3"
            data-name="Mesa de trabajo – 3"
            clipPath="url(#clip-Mesa_de_trabajo_3)"
          >
            <g
              id="Grupo_14769"
              data-name="Grupo 14769"
              transform="translate(-2.453 -2.278)"
            >
              <g
                id="Grupo_14768"
                data-name="Grupo 14768"
                transform="translate(8.788 6.854)"
              >
                <path
                  id="Trazado_14398"
                  data-name="Trazado 14398"
                  d="M41.45,39.181H37.384V34.53a.506.506,0,0,0-.49-.53H24.322a.506.506,0,0,0-.49.53v4.652H19.767A2.785,2.785,0,0,0,17,41.983v9.429a2.785,2.785,0,0,0,2.767,2.8h2.927v4.538a.506.506,0,0,0,.49.53H38.039a.506.506,0,0,0,.49-.53V54.213h2.927a2.781,2.781,0,0,0,2.767-2.8V41.983A2.793,2.793,0,0,0,41.45,39.181ZM24.858,35.025h11.5v4.157h-11.5ZM37.5,58.256H23.719v-9.11H37.5v9.11Zm5.694-6.844a1.757,1.757,0,0,1-1.742,1.776H38.523V48.633a.491.491,0,0,0-.49-.512H23.184a.491.491,0,0,0-.49.512v4.555H19.767a1.757,1.757,0,0,1-1.742-1.776V41.983a1.757,1.757,0,0,1,1.742-1.776H41.444a1.757,1.757,0,0,1,1.742,1.776v9.429Z"
                  transform="translate(-17 -34)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14399"
                  data-name="Trazado 14399"
                  d="M307.385,189h-5.273a.512.512,0,0,0,0,1.025h5.273a.512.512,0,0,0,0-1.025Z"
                  transform="translate(-285.395 -180.174)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14400"
                  data-name="Trazado 14400"
                  d="M177.112,333.025h2.329a.512.512,0,1,0,0-1.025h-2.329a.512.512,0,1,0,0,1.025Z"
                  transform="translate(-167.513 -315.032)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14401"
                  data-name="Trazado 14401"
                  d="M184.56,372h-7.448a.512.512,0,1,0,0,1.025h7.453A.512.512,0,1,0,184.56,372Z"
                  transform="translate(-167.513 -352.755)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14402"
                  data-name="Trazado 14402"
                  d="M184.56,412h-7.448a.512.512,0,0,0,0,1.025h7.453A.512.512,0,1,0,184.56,412Z"
                  transform="translate(-167.513 -390.477)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "dispositivos2":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.height ?? 38}
          height={props.height ?? 36}
          className={className}
          viewBox={`0 0 ${props.width ?? 38} ${props.height ?? 36}`}
        >
          <defs>
            <clipPath id="clip-Dispositivos-blanco">
              <rect width="38" height="36" />
            </clipPath>
          </defs>
          <g id="Dispositivos-blanco" clipPath="url(#clip-Dispositivos-blanco)">
            <g
              id="Grupo_14776"
              data-name="Grupo 14776"
              transform="translate(-2 -1)"
            >
              <g
                id="Grupo_14772"
                data-name="Grupo 14772"
                transform="translate(-278.703 -402.047)"
              >
                <path
                  id="Trazado_14403"
                  data-name="Trazado 14403"
                  d="M312.206,431.477l-3.275-14a5.488,5.488,0,0,0-.977-10.888H289.246l.353.851h-1.8a.506.506,0,0,0-.468.7l3.425,8.263a.505.505,0,0,0,.467.312h2.222l.353.851h3.147l1.351,3.283a1.753,1.753,0,0,0,3,.416l3.835,8.946.9-.388-5.242-12.229h7.156l3.161,13.513h-5.029a2.359,2.359,0,1,0,0,4.7h6.373a.638.638,0,0,0,.618-.788Zm-.82-22.313a4.463,4.463,0,0,1-1.325,3.083,4.523,4.523,0,0,1-3.207,1.319H293.262l-2.207-5.292a.506.506,0,0,1,.466-.7h16.434a4.5,4.5,0,0,1,3.431,1.591Zm-19.5,6.567a.505.505,0,0,1-.467-.312l-2.9-6.995h1.492l3.029,7.307Zm1.731-1.18H306.86a5.511,5.511,0,0,0,3.907-1.607,5.436,5.436,0,0,0,1.42-2.422,4.5,4.5,0,0,1-4.227,6.06h-13.5Zm6.609,6.341a.775.775,0,0,1-1.008-.419l-1.2-2.908h1.667l.956,2.32a.772.772,0,0,1-.42,1.007Zm5.861,13.931a1.38,1.38,0,0,1-.392-2.732,1.354,1.354,0,0,1,.392,0h5.261l.667,2.732Z"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14404"
                  data-name="Trazado 14404"
                  d="M307.1,411.967a1.7,1.7,0,1,1,.778-.19A1.7,1.7,0,0,1,307.1,411.967Zm0-2.412a.7.7,0,0,0-.326.08.716.716,0,1,0,.326-.08Z"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
              </g>
              <line
                id="Línea_228"
                data-name="Línea 228"
                x2="2.099"
                y2="4.853"
                transform="translate(25.479 24.69)"
                fill={props.fill}
                stroke={props.fill}
                strokeWidth="0.3"
                strokeMiterlimit="10"
              />
              <g
                id="Grupo_14774"
                data-name="Grupo 14774"
                transform="translate(2.715 0.767)"
              >
                <path
                  id="Trazado_14416"
                  data-name="Trazado 14416"
                  d="M1.326,6.954A.326.326,0,0,1,1,6.628v-1.3A.326.326,0,0,1,1.326,5h1.3a.326.326,0,0,1,0,.651H1.651v.977A.326.326,0,0,1,1.326,6.954Z"
                  transform="translate(4.875 18.413)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14417"
                  data-name="Trazado 14417"
                  d="M26.628,22.954h-1.3a.326.326,0,1,1,0-.651H26.3v-.977a.326.326,0,1,1,.651,0v1.3A.326.326,0,0,1,26.628,22.954Z"
                  transform="translate(-11.309 7.624)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14418"
                  data-name="Trazado 14418"
                  d="M2.628,22.954h-1.3A.326.326,0,0,1,1,22.628v-1.3a.326.326,0,1,1,.651,0V22.3h.977a.326.326,0,1,1,0,.651Z"
                  transform="translate(4.875 7.624)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14419"
                  data-name="Trazado 14419"
                  d="M26.628,6.954a.326.326,0,0,1-.326-.326V5.651h-.977a.326.326,0,0,1,0-.651h1.3a.326.326,0,0,1,.326.326v1.3A.326.326,0,0,1,26.628,6.954Z"
                  transform="translate(-11.309 18.413)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14420"
                  data-name="Trazado 14420"
                  d="M5.326,12.582A.326.326,0,0,1,5,12.257V9.326a.326.326,0,0,1,.651,0v2.931A.326.326,0,0,1,5.326,12.582Z"
                  transform="translate(2.178 15.716)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14421"
                  data-name="Trazado 14421"
                  d="M9.326,13.559A.326.326,0,0,1,9,13.234V9.326a.326.326,0,0,1,.651,0v3.908A.326.326,0,0,1,9.326,13.559Z"
                  transform="translate(-0.519 15.716)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14422"
                  data-name="Trazado 14422"
                  d="M13.326,12.582A.326.326,0,0,1,13,12.257V9.326a.326.326,0,1,1,.651,0v2.931A.326.326,0,0,1,13.326,12.582Z"
                  transform="translate(-3.217 15.716)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14423"
                  data-name="Trazado 14423"
                  d="M17.326,13.559A.326.326,0,0,1,17,13.234V9.326a.326.326,0,0,1,.651,0v3.908A.326.326,0,0,1,17.326,13.559Z"
                  transform="translate(-5.914 15.716)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14424"
                  data-name="Trazado 14424"
                  d="M21.326,12.582A.326.326,0,0,1,21,12.257V9.326a.326.326,0,1,1,.651,0v2.931A.326.326,0,0,1,21.326,12.582Z"
                  transform="translate(-8.612 15.716)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
                <path
                  id="Trazado_14425"
                  data-name="Trazado 14425"
                  d="M25.326,13.559A.326.326,0,0,1,25,13.234V9.326a.326.326,0,1,1,.651,0v3.908A.326.326,0,0,1,25.326,13.559Z"
                  transform="translate(-11.309 15.716)"
                  fill={props.fill}
                  stroke={props.fill}
                  strokeWidth="0.3"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "presis":
      return (
        <svg
          width="30"
          height="35"
          viewBox="0 0 30 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.389 6.43922L27.589 6.18222C22.489 5.45322 18.423 3.60622 15.507 0.690216C15.3705 0.561165 15.1898 0.489258 15.002 0.489258C14.8142 0.489258 14.6335 0.561165 14.497 0.690216C11.581 3.60622 7.51698 5.45422 2.41498 6.18222L0.614978 6.43922C0.521485 6.4531 0.431678 6.48541 0.350768 6.53427C0.269858 6.58313 0.199454 6.64757 0.14364 6.72385C0.0878255 6.80013 0.0477125 6.88673 0.0256263 6.97863C0.0035401 7.07053 -7.98935e-05 7.1659 0.0149776 7.25922L1.64498 17.4022C2.36039 22.1078 4.85635 26.3587 8.61698 29.2762L14.563 33.9012C14.6884 33.999 14.8429 34.0521 15.002 34.0521C15.161 34.0521 15.3155 33.999 15.441 33.9012L21.387 29.2762C25.1461 26.3608 27.6419 22.113 28.359 17.4102L29.99 7.26322C30.005 7.1699 30.0014 7.07453 29.9793 6.98263C29.9572 6.89073 29.9171 6.80413 29.8613 6.72785C29.8055 6.65157 29.7351 6.58713 29.6542 6.53827C29.5733 6.48941 29.4835 6.4571 29.39 6.44322L29.389 6.43922ZM26.951 17.1852C26.2896 21.5307 23.9837 25.4559 20.51 28.1492L15.002 32.4342L9.49498 28.1482C6.0204 25.454 3.71381 21.5279 3.05198 17.1812L1.53598 7.75222L2.61698 7.59822C7.20251 7.10582 11.526 5.2162 15.002 2.18522C18.4782 5.21548 22.8017 7.10439 27.387 7.59622L28.468 7.75022L26.951 17.1852Z"
            fill="white"
          />
          <path
            d="M20.002 12.754V10.48C20.002 10.1048 19.9281 9.73318 19.7844 9.38649C19.6408 9.0398 19.4303 8.7248 19.1648 8.45949C18.8994 8.19418 18.5844 7.98376 18.2376 7.84024C17.8909 7.69672 17.5193 7.62292 17.144 7.62305H12.859C12.1013 7.62305 11.3746 7.92405 10.8388 8.45984C10.303 8.99563 10.002 9.72232 10.002 10.48V12.754C9.58548 12.9012 9.22461 13.1735 8.96881 13.5337C8.71301 13.8939 8.57476 14.3243 8.573 14.766V22.623C8.573 22.9045 8.62843 23.1831 8.73612 23.4431C8.84382 23.7031 9.00167 23.9394 9.20067 24.1384C9.39966 24.3374 9.63591 24.4952 9.89591 24.6029C10.1559 24.7106 10.4346 24.766 10.716 24.766H19.287C19.5684 24.766 19.8471 24.7106 20.1071 24.6029C20.3671 24.4952 20.6033 24.3374 20.8023 24.1384C21.0013 23.9394 21.1592 23.7031 21.2669 23.4431C21.3746 23.1831 21.43 22.9045 21.43 22.623V14.766C21.428 14.3245 21.2897 13.8943 21.0339 13.5343C20.7781 13.1743 20.4174 12.9022 20.001 12.755L20.002 12.754ZM11.431 10.48C11.431 10.1011 11.5816 9.73758 11.8495 9.46959C12.1175 9.2016 12.481 9.05105 12.86 9.05105H17.146C17.5246 9.05158 17.8876 9.20236 18.1552 9.4703C18.4227 9.73823 18.573 10.1014 18.573 10.48V12.623H11.43L11.431 10.48ZM20.002 22.623C20.002 22.8124 19.9268 22.994 19.7929 23.1279C19.659 23.2618 19.4774 23.337 19.288 23.337H10.716C10.5266 23.337 10.345 23.2618 10.2111 23.1279C10.0772 22.994 10.002 22.8124 10.002 22.623V14.766C10.002 14.5767 10.0772 14.3951 10.2111 14.2612C10.345 14.1273 10.5266 14.052 10.716 14.052H19.287C19.4764 14.052 19.658 14.1273 19.7919 14.2612C19.9258 14.3951 20.001 14.5767 20.001 14.766L20.002 22.623Z"
            fill="white"
          />
          <path
            d="M15.001 15.48C14.4964 15.4795 14.0078 15.6575 13.6218 15.9825C13.2358 16.3075 12.9772 16.7585 12.8917 17.2558C12.8063 17.7531 12.8994 18.2646 13.1548 18.6999C13.4101 19.1351 13.8112 19.466 14.287 19.634V21.194C14.287 21.3835 14.3622 21.5652 14.4962 21.6992C14.6302 21.8332 14.812 21.9085 15.0015 21.9085C15.191 21.9085 15.3727 21.8332 15.5067 21.6992C15.6407 21.5652 15.716 21.3835 15.716 21.194V19.634C16.1918 19.4659 16.5929 19.135 16.8483 18.6996C17.1036 18.2643 17.1967 17.7527 17.1111 17.2553C17.0255 16.7579 16.7667 16.3069 16.3805 15.982C15.9943 15.6571 15.5056 15.4792 15.001 15.48ZM15.001 18.337C14.8597 18.337 14.7217 18.2951 14.6043 18.2167C14.4869 18.1382 14.3953 18.0267 14.3413 17.8962C14.2873 17.7658 14.2731 17.6222 14.3007 17.4837C14.3282 17.3452 14.3962 17.218 14.4961 17.1181C14.5959 17.0183 14.7232 16.9503 14.8617 16.9227C15.0002 16.8952 15.1437 16.9093 15.2742 16.9633C15.4047 17.0174 15.5162 17.1089 15.5946 17.2263C15.6731 17.3437 15.715 17.4818 15.715 17.623C15.715 17.8123 15.6397 17.994 15.5058 18.1279C15.3719 18.2618 15.1903 18.337 15.001 18.337Z"
            fill="white"
          />
        </svg>
      );
    case "tags":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width ?? 38}
          height={props.height ?? 36}
          className={className}
          viewBox={`0 0 ${props.width ?? 38} ${props.height ?? 36}`}
        >
          <g
            id="Mesa_de_trabajo_2"
            data-name="Mesa de trabajo – 2"
            clipPath="url(#clip-Mesa_de_trabajo_2)"
          >
            <g
              id="Grupo_14767"
              data-name="Grupo 14767"
              transform="translate(10346 -3899.725)"
            >
              <g
                id="Grupo_14766"
                data-name="Grupo 14766"
                transform="translate(-10341 3904)"
              >
                <g
                  id="Grupo_14761"
                  data-name="Grupo 14761"
                  transform="translate(0 0)"
                >
                  <path
                    id="Trazado_14393"
                    data-name="Trazado 14393"
                    d="M12.251,29.654a.539.539,0,0,1-.351-.146L1.146,18.754A.539.539,0,0,1,1,18.4a.484.484,0,0,1,.146-.351l12.6-12.6c.029-.029.058-.058.088-.058l4.208-4.237a.506.506,0,0,1,.5-.117l8.475,2.279a.439.439,0,0,1,.351.321l2.279,8.475a.523.523,0,0,1-.117.5l-4.237,4.208c-.029.029-.058.058-.058.088l-12.6,12.6A.615.615,0,0,1,12.251,29.654ZM2.227,18.4,12.28,28.456,24.437,16.3c.029-.029.058-.058.058-.088l4.062-4.091L26.453,4.2,18.534,2.1,14.472,6.159l-.088.088Z"
                    transform="translate(-1 -1.022)"
                    fill={props.fill}
                    stroke={props.fill}
                    strokeWidth="0.3"
                  />
                </g>
                <g
                  id="Grupo_14762"
                  data-name="Grupo 14762"
                  transform="translate(5.165 15.533)"
                >
                  <path
                    id="Trazado_14394"
                    data-name="Trazado 14394"
                    d="M26.1,62.1a.539.539,0,0,1-.351-.146L18.828,55.03a.5.5,0,0,1,.7-.7l6.926,6.926a.477.477,0,0,1,0,.7A.393.393,0,0,1,26.1,62.1Z"
                    transform="translate(-18.675 -54.175)"
                    fill={props.fill}
                    stroke={props.fill}
                    strokeWidth="0.3"
                  />
                </g>
                <g
                  id="Grupo_14763"
                  data-name="Grupo 14763"
                  transform="translate(7.532 13.166)"
                >
                  <path
                    id="Trazado_14395"
                    data-name="Trazado 14395"
                    d="M34.2,54.031a.539.539,0,0,1-.351-.146L26.928,46.93a.5.5,0,0,1,.7-.7l6.926,6.926a.477.477,0,0,1,0,.7A.457.457,0,0,1,34.2,54.031Z"
                    transform="translate(-26.775 -46.075)"
                    fill={props.fill}
                    stroke={props.fill}
                    strokeWidth="0.3"
                  />
                </g>
                <g
                  id="Grupo_14764"
                  data-name="Grupo 14764"
                  transform="translate(9.87 10.828)"
                >
                  <path
                    id="Trazado_14396"
                    data-name="Trazado 14396"
                    d="M42.2,46a.539.539,0,0,1-.351-.146L34.928,38.93a.5.5,0,0,1,.7-.7l6.926,6.926a.477.477,0,0,1,0,.7A.484.484,0,0,1,42.2,46Z"
                    transform="translate(-34.775 -38.075)"
                    fill={props.fill}
                    stroke={props.fill}
                    strokeWidth="0.3"
                  />
                </g>
                <g
                  id="Grupo_14765"
                  data-name="Grupo 14765"
                  transform="translate(16.306 5.254)"
                >
                  <path
                    id="Trazado_14397"
                    data-name="Trazado 14397"
                    d="M60.336,26.072h0a3.663,3.663,0,0,1-2.513-1.023A3.487,3.487,0,0,1,56.8,22.536a3.663,3.663,0,0,1,1.023-2.513A3.487,3.487,0,0,1,60.336,19a3.663,3.663,0,0,1,2.513,1.023,3.545,3.545,0,0,1,0,5A3.446,3.446,0,0,1,60.336,26.072Zm0-6.049a2.513,2.513,0,1,0,0,5.026h0a2.513,2.513,0,1,0,0-5.026Z"
                    transform="translate(-56.8 -19)"
                    fill={props.fill}
                    stroke={props.fill}
                    strokeWidth="0.3"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case "profiles":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="27"
          viewBox="0 0 28 28"
        >
          <g data-name="Grupo 16362" fill={props.fill}>
            <path
              data-name="Trazado 14943"
              d="M16.073 19.845c-.008-.076-.024-.149-.034-.224h7.7l-.106-1a5.733 5.733 0 0 0-4.148-4.907 3.683 3.683 0 1 0-3.211-.008 5.683 5.683 0 0 0-2.7 1.735 6.279 6.279 0 0 0-2.247-1.06 4.333 4.333 0 1 0-3.3.046 6.313 6.313 0 0 0-4.553 5.413l-.107 1h12.821Zm-3.931-9.427a2.53 2.53 0 1 1-2.53-2.528 2.537 2.537 0 0 1 2.529 2.529Zm5.748 1.887a1.886 1.886 0 1 1 0-3.771 1.886 1.886 0 0 1 0 3.772Zm-3.05 4.408a3.94 3.94 0 0 1 3.049-1.442h.011a3.988 3.988 0 0 1 3.707 2.553h-6.1a6.324 6.324 0 0 0-.667-1.111Zm-9.356 2.329a4.535 4.535 0 0 1 4.283-3.052h.019a4.533 4.533 0 0 1 4.282 3.052Z"
            />
            <path
              data-name="Trazado 14944"
              d="M25.542 0H1.456A1.461 1.461 0 0 0 0 1.456v24.088A1.46 1.46 0 0 0 1.456 27h24.086a1.46 1.46 0 0 0 1.457-1.457V1.455A1.459 1.459 0 0 0 25.542 0Zm-.341 1.8v23.4H1.796V1.8Z"
            />
          </g>
        </svg>
      );
    case "edit_code_template":
      return (
        <svg
          width="30"
          height="30"
          viewBox="0 0 28 28"
          xmlns="http://www.w3.org/2000/svg"
          className="edit_code_template"
        >
          <path
            id="icon-code"
            d="M5.67578 0.75H16.9648C17.4288 0.749982 17.8373 0.749961 18.1914 0.764648L18.5273 0.785156C18.9173 0.817013 19.2894 0.880979 19.6445 1.0332L19.7959 1.10449C20.331 1.37715 20.7786 1.79167 21.0908 2.30078L21.2158 2.52441C21.3688 2.82468 21.4519 3.13735 21.499 3.46289L21.5352 3.79297C21.5698 4.21756 21.5703 4.73704 21.5703 5.35547V16.6455C21.5703 17.1092 21.5704 17.5171 21.5557 17.8711L21.5352 18.207C21.5033 18.597 21.4393 18.9691 21.2871 19.3242L21.2158 19.4756C20.9432 20.0107 20.5286 20.4583 20.0195 20.7705L19.7959 20.8955C19.4956 21.0485 19.183 21.1316 18.8574 21.1787L18.5273 21.2148C18.1029 21.2495 17.584 21.25 16.9658 21.25H5.67578C5.21184 21.25 4.80337 21.25 4.44922 21.2354L4.11328 21.2148C3.72335 21.183 3.35117 21.119 2.99609 20.9668L2.84473 20.8955C2.30967 20.6229 1.86203 20.2083 1.5498 19.6992L1.4248 19.4756C1.27181 19.1753 1.18874 18.8627 1.1416 18.5371L1.10547 18.207C1.07079 17.7825 1.07029 17.2631 1.07031 16.6445V5.35547L1.0752 4.50098C1.07738 4.37093 1.08007 4.24692 1.08496 4.12891L1.10547 3.79297C1.13733 3.40305 1.20129 3.03087 1.35352 2.67578L1.4248 2.52441C1.69747 1.98937 2.112 1.54172 2.62109 1.22949L2.84473 1.10449C3.145 0.951499 3.45767 0.868428 3.7832 0.821289L4.11328 0.785156C4.32549 0.767824 4.56128 0.759259 4.82129 0.754883L5.67578 0.75ZM5.7207 2.58301C5.21945 2.58301 4.84265 2.58368 4.54102 2.5957L4.2627 2.6123C4.01372 2.63264 3.86434 2.66414 3.76367 2.7002L3.67676 2.7373C3.44339 2.85624 3.2484 3.03765 3.1123 3.25977L3.05762 3.35645C3.01979 3.43068 2.9834 3.53635 2.95605 3.72461L2.93262 3.94238C2.9046 4.28548 2.90332 4.7322 2.90332 5.40039V16.5996C2.90332 17.1009 2.90399 17.4777 2.91602 17.7793L2.93262 18.0576C2.95296 18.3066 2.98447 18.456 3.02051 18.5566L3.05762 18.6436C3.17658 18.877 3.358 19.0719 3.58008 19.208L3.67676 19.2627C3.75098 19.3005 3.85664 19.3369 4.04492 19.3643L4.2627 19.3877C4.60577 19.4157 5.05246 19.417 5.7207 19.417H16.9199C17.4212 19.417 17.798 19.4163 18.0996 19.4043L18.3779 19.3877C18.6269 19.3673 18.7763 19.3358 18.877 19.2998L18.9639 19.2627C19.197 19.1439 19.3922 18.963 19.5283 18.7412L19.583 18.6436C19.6208 18.5693 19.6572 18.4636 19.6846 18.2754L19.708 18.0576C19.736 17.7145 19.7373 17.2679 19.7373 16.5996V5.40039C19.7373 4.89911 19.7366 4.52232 19.7246 4.2207L19.708 3.94238C19.6877 3.69339 19.6562 3.54402 19.6201 3.44336L19.583 3.35645C19.4642 3.12336 19.2834 2.9281 19.0615 2.79199L18.9639 2.7373C18.8896 2.69952 18.7839 2.66309 18.5957 2.63574L18.3779 2.6123C18.0348 2.58429 17.5881 2.58301 16.9199 2.58301H5.7207ZM11.3203 13.583H15.9873C16.4934 13.5832 16.9033 13.9938 16.9033 14.5C16.9033 15.0062 16.4934 15.4168 15.9873 15.417H11.3203C10.814 15.417 10.4033 15.0063 10.4033 14.5C10.4033 13.9937 10.814 13.583 11.3203 13.583ZM5.98047 6.87793C6.30242 6.52951 6.83176 6.48766 7.20312 6.7666L7.27539 6.82617L10.7754 10.0576V10.0566C10.9319 10.2012 11.0324 10.3954 11.0615 10.6045L11.0693 10.6953C11.0775 10.9084 11.0116 11.1169 10.8838 11.2852L10.8252 11.3545L7.3252 15.124C6.98077 15.4947 6.40121 15.516 6.03027 15.1719C5.68244 14.8489 5.64166 14.3189 5.92188 13.9482L5.98145 13.876L8.68555 10.9648L8.85645 10.7803L8.67188 10.6104L6.03223 8.17383C5.68345 7.85188 5.64085 7.32169 5.91992 6.9502L5.98047 6.87793Z"
            fill={props.fill}
            stroke="#3C7AF5"
            strokeWidth="0.5"
          />
        </svg>
      );
    case "yax":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width ?? 29.229}
          height={props.height ?? 31.188}
          className={className}
          viewBox={`0 0 ${props.width ?? 29.229} ${props.height ?? 31.188}`}
        >
          <g
            id="Grupo_14546"
            data-name="Grupo 14546"
            transform="translate(-652.564 -242.497)"
          >
            <path
              id="Trazado_13853"
              data-name="Trazado 13853"
              d="M706.357,285.8l-6.042-6.386c-.718.645-1.8,1.864-1.8,1.864l.013.042c.072-.1.145-.192.216-.281l6.081,6.427.1.1a3.413,3.413,0,0,1,.825,4.355c-.273.49-.71,1.092-1.246,1.175a1.843,1.843,0,0,1-1.321-.527l-4.978-5.055a5.6,5.6,0,0,1-.337-.453,18.554,18.554,0,0,0,4.87,6.708c.835.715,2.905,1.324,4.227.233.085-.07.159-.139.24-.208a6.658,6.658,0,0,0,.467-.721A5.739,5.739,0,0,0,706.357,285.8Z"
              transform="translate(-26.661 -21.724)"
              fill={props.fill ?? "#a9b1d1"}
            />
            <path
              id="Trazado_13854"
              data-name="Trazado 13854"
              d="M676.1,272.042a18.551,18.551,0,0,1-4.87-6.709,3.862,3.862,0,0,1-.71-2.544,6.409,6.409,0,0,1,1.366-3.195l-.013-.042s1.084-1.219,1.8-1.864l-.008-.009,5.656-5.774c1.517-1.376,3.741-4.7,1.471-7.616a4.011,4.011,0,0,0-3.164-1.774H677.6a5.217,5.217,0,0,0-3.641,1.934c-.386.406-4.727,4.962-6.185,6.368a1.156,1.156,0,0,1-.579.35,1.174,1.174,0,0,1-.579-.35c-1.458-1.407-5.835-5.982-6.222-6.388a5.217,5.217,0,0,0-3.641-1.934h-.025a4.012,4.012,0,0,0-3.164,1.774c-2.271,2.915-.046,6.24,1.471,7.616l5.693,5.793-.006.007a15.393,15.393,0,0,1,1.932,2.11,6.212,6.212,0,0,1,1.22,2.993,3.882,3.882,0,0,1-.745,2.6,18.584,18.584,0,0,1-4.848,6.654c-.835.715-2.905,1.324-4.227.233-.072-.06-.135-.118-.2-.177a3.627,3.627,0,0,0,2.378,1.554,3.1,3.1,0,0,0,.448.032,4.172,4.172,0,0,0,2.724-1.2l5.01-5.087.058-.064a6.372,6.372,0,0,0,1.616-4.752c-.272-3.316-3.078-5.873-3.488-6.23l-6.084-6.188c-.027-.025-2.742-2.5-1.223-4.448a1.941,1.941,0,0,1,1.447-.919h.016a3.11,3.11,0,0,1,1.971,1.146s4.705,4.932,6.315,6.494a2.881,2.881,0,0,0,1.892,1.032,2.447,2.447,0,0,0,.268.007,2.341,2.341,0,0,0,.262-.007,2.88,2.88,0,0,0,1.891-1.031c1.609-1.561,6.276-6.471,6.276-6.471a3.117,3.117,0,0,1,1.99-1.151,1.942,1.942,0,0,1,1.447.919c1.506,1.934-1.114,4.348-1.224,4.448l-6.046,6.169c-.41.357-3.216,2.914-3.488,6.23a6.371,6.371,0,0,0,1.617,4.752L675,272.494a4.168,4.168,0,0,0,2.72,1.191,3.092,3.092,0,0,0,.447-.032,3.641,3.641,0,0,0,2.4-1.585c-.081.07-.156.138-.24.208C679,273.366,676.932,272.757,676.1,272.042Z"
              transform="translate(-0.018 0)"
              fill={props.fill ?? "#a9b1d1"}
            />
            <path
              id="Trazado_13855"
              data-name="Trazado 13855"
              d="M658.264,293.763a18.586,18.586,0,0,0,4.848-6.654c-.093.133-.192.266-.3.4l-4.968,5.044a1.849,1.849,0,0,1-1.332.538c-.536-.083-.973-.685-1.246-1.175a3.41,3.41,0,0,1,.82-4.351l6.191-6.528c.119.149.241.312.361.482a15.386,15.386,0,0,0-1.932-2.11L654.66,285.8a5.738,5.738,0,0,0-1.317,7.271,6.593,6.593,0,0,0,.489.752c.07.059.133.118.2.177C655.359,295.087,657.429,294.478,658.264,293.763Z"
              transform="translate(0 -21.721)"
              fill={props.fill ?? "#a9b1d1"}
            />
          </g>
        </svg>
      );

    case "copy":
      return (
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 469.333 469.333"
          style="enableBackground:'new 0 0 469.333 469.333'"
        >
          <g>
            <g>
              <g>
                <path
                  fill={props.fill}
                  d="M330.667,0h-256C51.093,0,32,19.093,32,42.667v298.667h42.667V42.667h256V0z"
                />
                <path
                  d="M394.667,85.333H160c-23.573,0-42.667,19.093-42.667,42.667v298.667c0,23.573,19.093,42.667,42.667,42.667h234.667
                c23.573,0,42.667-19.093,42.667-42.667V128C437.333,104.427,418.24,85.333,394.667,85.333z M394.667,426.667H160V128h234.667
                V426.667z"
                />
              </g>
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );
    case "schedule":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="20"
          viewBox="0 0 18 20"
          class="react-daterange-picker__calendar-button__icon react-daterange-picker__button__icon"
          fill="black"
        >
          <path
            id="ic_date_range_24px"
            d="M9,11H7v2H9Zm4,0H11v2h2Zm4,0H15v2h2Zm2-7H18V2H16V4H8V2H6V4H5A1.991,1.991,0,0,0,3.01,6L3,20a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,19,4Zm0,16H5V9H19Z"
            transform="translate(-3 -2)"
            fill="currentColor"
          />
        </svg>
      );
    case "indeterminate-check":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.4058 0H5.40576C2.64434 0 0.405762 2.23858 0.405762 5V15C0.405762 17.7614 2.64434 20 5.40576 20H15.4058C18.1672 20 20.4058 17.7614 20.4058 15V5C20.4058 2.23858 18.1672 0 15.4058 0Z"
            fill="#62D862"
          />
          <rect x="4.40576" y="9" width="12" height="2" fill="white" />
        </svg>
      );
    case "arc":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.69 40" width="28" height="34" fill="#fff"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M23,22.48h0a.78.78,0,0,0-.52.21h0a7.94,7.94,0,0,1-11.17,0,.78.78,0,0,0-.52-.21h0a.8.8,0,0,0-.53.23.73.73,0,0,0-.22.52.74.74,0,0,0,.21.53,9.48,9.48,0,0,0,13.31,0,.74.74,0,0,0,.21-.53.73.73,0,0,0-.22-.52A.76.76,0,0,0,23,22.48Z"/><path class="cls-1" d="M12.54,20.29a.71.71,0,0,0-.57,0,.6.6,0,0,0-.25.16.78.78,0,0,0-.16.24.75.75,0,0,0-.06.29.72.72,0,0,0,.06.29.82.82,0,0,0,.16.25,7.25,7.25,0,0,0,10.25,0,.77.77,0,0,0,.22-.54.75.75,0,0,0-.22-.53.79.79,0,0,0-.54-.22h0a.75.75,0,0,0-.53.22,5.78,5.78,0,0,1-8.11,0A.6.6,0,0,0,12.54,20.29Z"/><path class="cls-1" d="M20.44,19.27h0a.74.74,0,0,0,.21-.53A.75.75,0,0,0,19.9,18h0a.74.74,0,0,0-.53.21,3.59,3.59,0,0,1-5.05,0,.75.75,0,0,0-.53-.22h0a.75.75,0,0,0-.75.76.75.75,0,0,0,.22.53,5.11,5.11,0,0,0,7.19,0Z"/><path class="cls-1" d="M32.4,17.69a.8.8,0,0,0,.53.21.78.78,0,0,0,.53-.21.72.72,0,0,0,.23-.53v-10a2.89,2.89,0,0,0-.84-2,2.82,2.82,0,0,0-2-.83H24l-.81-2.72A2.14,2.14,0,0,0,22.41.43,2.19,2.19,0,0,0,21.13,0H18.71a.81.81,0,0,0-.53.22A.83.83,0,0,0,18,.76a.8.8,0,0,0,.21.53.77.77,0,0,0,.53.22h2.42a.67.67,0,0,1,.38.13.64.64,0,0,1,.23.33l.68,2.29H11.36L12,2a.64.64,0,0,1,.23-.33.6.6,0,0,1,.38-.13h2.91a.75.75,0,0,0,.29-.06.63.63,0,0,0,.24-.16.81.81,0,0,0,.17-.24.75.75,0,0,0,.06-.29.72.72,0,0,0-.06-.29.74.74,0,0,0-.17-.25.63.63,0,0,0-.24-.16A.75.75,0,0,0,15.56,0H12.65a2.16,2.16,0,0,0-1.28.42,2.21,2.21,0,0,0-.78,1.12l-.8,2.72H2.86a2.82,2.82,0,0,0-2,.83,2.89,2.89,0,0,0-.84,2V39.25a.71.71,0,0,0,.06.28.72.72,0,0,0,.16.25.67.67,0,0,0,.25.16A.72.72,0,0,0,.76,40H7a.71.71,0,0,0,.28-.06.6.6,0,0,0,.25-.16.72.72,0,0,0,.16-.25.71.71,0,0,0,.06-.28V16.52a.68.68,0,0,0-.06-.29A.6.6,0,0,0,7.54,16a.63.63,0,0,0-.24-.16.73.73,0,0,0-.58,0,.67.67,0,0,0-.25.16.72.72,0,0,0-.16.25.68.68,0,0,0-.06.29v22H1.51v-24H15.82a.75.75,0,0,0,.53-.22.77.77,0,0,0,.22-.53.75.75,0,0,0-.22-.53.76.76,0,0,0-.53-.23H11.49V9.78a.65.65,0,0,1,.64-.64h9.43a.65.65,0,0,1,.45.19.64.64,0,0,1,.19.45v1.14a.77.77,0,0,0,.22.53.82.82,0,0,0,.53.21.75.75,0,0,0,.76-.74V9.78a2.15,2.15,0,0,0-2.15-2.15H12.13a2.13,2.13,0,0,0-1.52.63A2.18,2.18,0,0,0,10,9.78V13H1.51V7.11a1.31,1.31,0,0,1,.4-1,1.34,1.34,0,0,1,1-.39h28a1.34,1.34,0,0,1,1,.39,1.31,1.31,0,0,1,.4,1V13H19a.76.76,0,0,0-.53.23.75.75,0,0,0-.22.53.77.77,0,0,0,.22.53.75.75,0,0,0,.53.22h7V39.25a.67.67,0,0,0,.06.28.6.6,0,0,0,.16.25.63.63,0,0,0,.24.16.79.79,0,0,0,.29.06h6.25a.72.72,0,0,0,.29-.06.67.67,0,0,0,.25-.16.72.72,0,0,0,.16-.25.67.67,0,0,0,.06-.28V20.31a.71.71,0,0,0-.23-.52.75.75,0,0,0-1.06,0,.73.73,0,0,0-.22.52V38.49H27.44v-24h4.74v2.69A.75.75,0,0,0,32.4,17.69Z"/></g></g></svg>
      )

    default:
      return <path />;
  }
};

const SVGIcon = ({ className = "", fill = "#171926", name, width, height }) => {
  return (
    <React.Fragment>
      {getPath(name, className, { fill, width, height })}
    </React.Fragment>
  );
};

export default SVGIcon;
